/*
* @描述: 自定义表单
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-10-28 15:34:42
*/
<template>
    <div v-loading="loading" class="custom_form_site_wrap">
        <div class="custom_form_site_outer_wrap">
            <div class="left_components_wrap">
                <ul v-if="is_show_control_group" class="components_options_tabs">
                    <li :class="{'active':components_options_tab==='controls'}"
                        class="components_options_tab"
                        @click="components_options_tab='controls'">控件
                    </li>
                    <li :class="{'active':components_options_tab==='control_group'}"
                        class="components_options_tab"
                        @click="components_options_tab='control_group'">控件组
                    </li>
                </ul>
                <div v-if="components_options_tab==='controls'"
                     :style="{ 'height': is_show_control_group ? 'calc(100% - 65px)' : '100%'}"
                     class="controls_outer_wrap">
                    <h2>控件选择区</h2>
                    <p class="title_desc"
                       v-text="is_form_module ? '可拖动控件至右侧表单分组中' : '可拖拽控件至右侧表单预览区'"></p>
                    <ul class="components_options_list">
                        <li v-for="control in controlOptionsList"
                            :key="control.value"
                            class="components_options_item">
                            <div class="flex_wrap mb_12">
                                <img v-if="control.value==='popular_control'"
                                     alt=""
                                     class="popular_control_icon"
                                     src="https://download.hecoos.com/enlightv/2025-02/d7a06aa649bed97a9c2f967593caa9c2.png">
                                <h3 v-text="control.title"></h3>
                            </div>
                            <ul class="control_types_list">
                                <draggable :animation="300"
                                           :clone="cloneComponent"
                                           :group="{ name: 'componentsGroup', pull: 'clone', put: false }"
                                           :list="control.types"
                                           :move="onDragComponentsMove"
                                           :sort="false"
                                           chosenClass="chosen"
                                           class="control_draggable"
                                           draggable=".control_types_item"
                                           @choose="onDragComponentsChoose"
                                           @end="onDragComponentsEnd">
                                    <li v-for="item in control.types"
                                        :key="item.type"
                                        class="control_types_item"
                                        @click="handleSelectControl(item)">
                                        <span class="control_types_name" v-text="item.field_name"></span>
                                        <i :class="'iconfont ' + item.icon" class="control_types_icon"></i>
                                    </li>
                                </draggable>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div v-else-if="components_options_tab==='control_group'"
                     class="control_group_outer_wrap">
                    <ul class="components_options_list">
                        <li v-for="control in controlsOptionsList"
                            :key="control.value"
                            class="components_options_item">
                            <div class="flex_wrap mb_12">
                                <h3 v-text="control.title"></h3>
                            </div>
                            <ul class="control_types_list">
                                <draggable :animation="300"
                                           :sort="false"
                                           class="control_draggable"
                                           draggable="">
                                    <li v-for="item in control.types"
                                        :key="item.type"
                                        :class="{'is_disabled': item.hasOwnProperty('disabled')&&!item.disabled}"
                                        class="control_types_item"
                                        @click="handleSelectControlGroup(item)">
                                        <span class="control_types_name" v-text="item.field_name"></span>
                                        <i :class="'iconfont ' + item.icon" class="control_types_icon"></i>
                                    </li>
                                </draggable>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="center_form_wrap">
                <div class="center_title_wrap">
                    <div>
                        <h2 v-text="field_form_title"></h2>
                        <p class="title_desc" v-text="field_form_desc"></p>
                    </div>
                    <div>
                        <el-button v-if="review_btn_show&&review_form_type_list.length&&formInfoList.length"
                                   :disabled="btnDisabled"
                                   plain
                                   size="mini"
                                   type="primary"
                                   @click="handleClickReview">预览
                        </el-button>
                        <el-button v-if="publish_btn_show"
                                   :disabled="btnDisabled"
                                   size="mini"
                                   type="primary"
                                   @click="handleClickPublish">发布
                        </el-button>
                    </div>
                </div>
                <div class="center_form_review_wrap">
                    <el-form size="small">
                        <draggable :animation="300"
                                   :group="is_form_module?'':'componentsGroup'"
                                   :list="formInfoList"
                                   :move="onDragCenterFormItemMove"
                                   :scroll="true"
                                   class="form_module_content_wrap"
                                   filter=".is_can_not_drag"
                                   @end="onDragCenterFormItemEnd">
                            <template v-if="formInfoList.length">
                                <div v-for="field in formInfoList.filter(item=>!item.extend.set_form_hide)"
                                     :key="field.field_key"
                                     :class="{'is_can_not_drag':field.extend.hasOwnProperty('can_draggable')}"
                                     :style="{'width':field.extend.col_span===12 ?'50%':'100%'}"
                                     @click="handleClickCenterFormItem(field)">
                                    <div v-if="field.field_type==='form_module'"
                                         :class="{'active': field.field_key===componentPropertyForm.field_key}"
                                         class="form_module_wrap">
                                        <div class="form_module_title_wrap">
                                            <div v-if="field.field_name_edit" @click.stop>
                                                <el-input :ref="`field_name_input_${field.field_key}`"
                                                          v-model="field.field_name"
                                                          class="field_name_input"
                                                          maxlength="12"
                                                          placeholder="请输入分组标题"
                                                          size="small"
                                                          @blur="handleFieldNameInputBlur(field)"
                                                          @keyup.enter.native="handleFieldNameEnter(field)"></el-input>
                                            </div>
                                            <div v-else :class="{'can_edit':field.is_system===0}"
                                                 class="field_name_wrap">
                                                <span class="field_name" v-text="field.field_name"></span>
                                                <span class="handle_icon_wrap edit_icon_wrap"
                                                      @click.stop="handleClickEditFieldName(field)">
                                                    <i class="iconfont icon-bianji"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <el-checkbox v-if="field.extend.hasOwnProperty('can_set_discontinue')"
                                                             v-model="field.extend.hidden_field"
                                                             @click.stop>停用
                                                </el-checkbox>
                                                <div v-if="field.is_system===0"
                                                     class="handle_icon_wrap handle_icon_danger_wrap"
                                                     @click.stop="handleClickDeleteFormModule(field.field_key)">
                                                    <i class="el-icon-delete"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <draggable :animation="300"
                                                   :list="field._child"
                                                   :move="onDragCenterFormItemMove"
                                                   :scroll="true"
                                                   class="form_module_content_wrap"
                                                   filter=".is_can_not_drag"
                                                   group="componentsGroup"
                                                   handle=".field_outer_wrap"
                                                   @end="onDragCenterFormItemEnd">
                                            <template v-if="field._child&&field._child.length">
                                                <div v-for="child in field._child"
                                                     :key="child.field_key"
                                                     :class="{'p_0':child.field_type==='goods','active': child.field_key===componentPropertyForm.field_key,'is_can_not_drag':child.extend.hasOwnProperty('can_draggable')}"
                                                     :style="{'width':child.extend.col_span===12 ?'50%':'100%'}"
                                                     class="field_outer_wrap"
                                                     @click.stop="handleClickFormModuleFieldItem(child,field)">
                                                    <el-form-item>
                                                        <div v-if="!child.extend.hasOwnProperty('field_name_show')"
                                                             class="center_field_label">
                                                            <div v-if="child.field_name_edit" @click.stop>
                                                                <el-input
                                                                        :ref="`field_name_input_${child.field_key}`"
                                                                        v-model="child.field_name"
                                                                        class="field_name_input"
                                                                        maxlength="12"
                                                                        placeholder="请输入标题"
                                                                        size="small"
                                                                        @blur="handleFieldNameInputBlur(child)"
                                                                        @keyup.enter.native="handleFieldNameEnter(child)">
                                                                </el-input>
                                                            </div>
                                                            <div v-else
                                                                 :class="{'is_required':child.is_required===1,'can_edit':(child.is_system===0||(child.is_system===1&&child.is_reset===1))&&child.field_type!=='order_amount_compute_mode'}"
                                                                 class="field_name_wrap">
                                                                <span class="field_name"
                                                                      v-text="child.field_name"></span>
                                                                <el-tooltip :content="child.extend.formula"
                                                                            effect="dark"
                                                                            placement="top">
                                                                    <span v-if="child.field_type=='order_amount_compute_mode'&&child.extend.filling_method==='1'"
                                                                          class="handle_icon_wrap">
                                                                        <i class="iconfont icon-yiwen"></i>
                                                                    </span>
                                                                </el-tooltip>
                                                                <span class="handle_icon_wrap edit_icon_wrap"
                                                                      @click.stop="handleClickEditFieldName(child)">
                                                                    <i class="iconfont icon-bianji"></i>
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <el-checkbox
                                                                        v-if="child.extend.hasOwnProperty('can_set_discontinue')"
                                                                        v-model="child.extend.hidden_field"
                                                                        @click.stop>停用
                                                                </el-checkbox>
                                                                <el-checkbox v-if="child.field_type!=='explain'"
                                                                             v-model="child.is_required"
                                                                             :disabled="(child.is_system===1&&!child.extend.hasOwnProperty('system_can_set_required'))||child.field_type==='serial_number'||child.field_type==='order_amount_compute_mode'||child.field_type==='compute_mode'"
                                                                             :false-label="0"
                                                                             :true-label="1"
                                                                             @change="handleFieldIsRequiredChange(child)"
                                                                             @click.stop>
                                                                    必填
                                                                </el-checkbox>
                                                                <i :class="{'is_disabled':child.is_system===1}"
                                                                   class="el-icon-remove"
                                                                   @click.stop="handleClickDeleteFormModuleField(child,field._child)"></i>
                                                            </div>
                                                        </div>
                                                        <customField :componentPropertyForm="componentPropertyForm"
                                                                     :field="child"
                                                                     @handleClickDeleteTableField="handleClickDeleteFormModuleField"
                                                                     @handleClickTableFieldItem="handleClickFormModuleFieldItem"/>
                                                    </el-form-item>
                                                </div>
                                            </template>
                                            <div v-else style="flex: 1">
                                                <div v-if="field.field_key==='amount_information'"
                                                     class="amount_information_hint">请点击此处并在页面右侧进行设置
                                                </div>
                                                <div v-else class="form_module_empty_wrap">拖拽控件至此处添加</div>
                                            </div>
                                        </draggable>
                                    </div>
                                    <div v-else
                                         :class="{'active': field.field_key===componentPropertyForm.field_key}"
                                         class="field_outer_wrap"
                                         @click.stop="handleClickFormModuleFieldItem(field)">
                                        <div v-if="field.field_type==='control'">
                                            <div class="center_field_label">
                                                <div class="page_little_title">
                                                    <div class="title" v-text="field.field_name"></div>
                                                </div>
                                                <i class="el-icon-remove"
                                                   @click.stop="handleClickDeleteFormModuleField(field,formInfoList)"></i>
                                            </div>
                                            <el-form-item
                                                    v-for="child in field._child.filter(child=>!child.extend.initial_display)">
                                                <div class="center_field_label">
                                                    <div :class="{'is_required':child.is_required===1}"
                                                         class="field_name_wrap">
                                                        <span class="field_name" v-text="child.field_name"></span>
                                                    </div>
                                                    <div>
                                                        <el-checkbox
                                                                v-if="child.extend.hasOwnProperty('can_set_required')"
                                                                v-model="child.is_required"
                                                                :false-label="0"
                                                                :true-label="1"
                                                                @change="handleFieldIsRequiredChange(child)"
                                                                @click.stop>必填
                                                        </el-checkbox>
                                                        <i v-if="child.extend.hasOwnProperty('is_show_switch')"
                                                           class="el-icon-remove"
                                                           @click.stop="handleClickDeleteControlGroupField(child)"></i>
                                                    </div>
                                                </div>
                                                <customField :componentPropertyForm="child"
                                                             :field="child"
                                                             :field_form="field_form"
                                                             @handleClickDeleteControlGroupField="handleClickDeleteControlGroupField"/>
                                            </el-form-item>
                                        </div>
                                        <el-form-item v-else>
                                            <div class="center_field_label">
                                                <div v-if="field.field_name_edit" @field.stop>
                                                    <el-input :ref="`field_name_input_${field.field_key}`"
                                                              v-model="field.field_name"
                                                              class="field_name_input"
                                                              maxlength="12"
                                                              placeholder="请输入标题"
                                                              size="small"
                                                              @blur="handleFieldNameInputBlur(field)"
                                                              @keyup.enter.native="handleFieldNameEnter(field)">
                                                    </el-input>
                                                </div>
                                                <div v-else
                                                     :class="{'is_required':field.is_required===1,'can_edit':field.is_system===0}"
                                                     class="field_name_wrap">
                                                    <span class="field_name" v-text="field.field_name"></span>
                                                    <span class="handle_icon_wrap edit_icon_wrap"
                                                          @click.stop="handleClickEditFieldName(field)">
                                                    <i class="iconfont icon-bianji"></i>
                                                </span>
                                                </div>
                                                <div>
                                                    <el-checkbox
                                                            v-if="field.extend.hasOwnProperty('can_set_discontinue')"
                                                            v-model="field.extend.hidden_field"
                                                            @click.stop>停用
                                                    </el-checkbox>
                                                    <el-checkbox
                                                            v-if="field.field_type!=='explain'&&field_form!=='project_stage_tasks'"
                                                            v-model="field.is_required"
                                                            :disabled="(field.is_system===1&&!field.extend.hasOwnProperty('system_can_set_required'))||field.field_type==='serial_number'||field.field_type==='order_amount_compute_mode'||field.field_type==='compute_mode'"
                                                            :false-label="0"
                                                            :true-label="1"
                                                            @change="handleFieldIsRequiredChange(field)"
                                                            @click.stop>必填
                                                    </el-checkbox>
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click.stop="handleClickDeleteFormModuleField(field,formInfoList)">
                                                        <i :class="{'is_disabled':field.is_system===1}"
                                                           class="el-icon-remove"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <customField :componentPropertyForm="componentPropertyForm"
                                                         :field="field"
                                                         :field_form="field_form"
                                                         @handleClickDeleteTableField="handleClickDeleteFormModuleField"
                                                         @handleClickTableFieldItem="handleClickFormModuleFieldItem"
                                                         @handleFieldIsRequiredChange="handleFieldIsRequiredChange"/>
                                        </el-form-item>
                                    </div>
                                </div>
                            </template>
                            <div v-else class="form_module_empty_wrap">
                                拖拽控件至此处添加
                            </div>
                        </draggable>
                    </el-form>
                    <div v-if="is_form_module" class="center_add_form_module_btn" @click="handleClickAddFormModule">
                        <i class="el-icon-plus"></i>
                        <span>添加分组</span>
                    </div>
                </div>
            </div>
            <div class="right_components_site_wrap">
                <div v-if="componentPropertyForm.field_key" class="right_components_inner_wrap">
                    <h2 v-text="componentPropertyForm.field_name"></h2>
                    <div class="right_components_form_wrap">
                        <el-radio-group v-if="componentPropertyForm.field_key!=='amount_information'"
                                        v-model="basicSettingGroup"
                                        class="title_radio_group"
                                        size="small"
                                        @change="handleBasicSettingGroupChange">
                            <el-radio-button label="basic">基础设置</el-radio-button>
                            <el-radio-button
                                    v-if="can_set_show_rules&&componentPropertyForm.is_system===0&&componentPropertyForm.field_type!=='form_module'&&componentPropertyForm.field_type!=='control'&&!componentPropertyForm.extend.hasOwnProperty('can_set_show_rules')"
                                    label="revealing">显隐设置
                            </el-radio-button>
                        </el-radio-group>
                        <el-form ref="componentPropertyForm"
                                 :model="componentPropertyForm"
                                 :rules="componentPropertyFormRules"
                                 label-position="top"
                                 size="small">
                            <div v-if="basicSettingGroup==='basic'">
                                <div v-if="componentPropertyForm.is_system === 1">
                                    <div v-if="componentPropertyForm.is_reset===1&&!componentPropertyForm.extend.hasOwnProperty('system_can_set_required')">
                                        <div v-if="componentPropertyForm.field_type==='contact'">
                                            <el-form-item label="标题" prop="field_name">
                                                <el-input v-model="componentPropertyForm.field_name"
                                                          maxlength="12"
                                                          placeholder="请输入标题"
                                                          @blur="handlePropertyFormFieldNameInputBlur"></el-input>
                                            </el-form-item>
                                            <el-form-item label="">
                                                <el-checkbox v-model="componentPropertyForm.extend.default">新增时自动带出创建人
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                        <div v-if="componentPropertyForm.field_type==='textarea'">
                                            <el-form-item label="" prop="">
                                                <el-checkbox v-model="componentPropertyForm.extend.initial_display">
                                                    隐藏字段
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='form_module'">
                                            <ul class="amount_information_list">
                                                <draggable v-model="componentPropertyForm._child"
                                                           :animation="300"
                                                           :forceFallback="true"
                                                           handle=".amount_information_item"
                                                           @end="onDragAmountInfoItemEnd">
                                                    <li v-for="(item,index) in componentPropertyForm._child"
                                                        :key="item.field_key"
                                                        class="amount_information_item">
                                                        <div class="flex_js_wrap">
                                                            <div class="flex_wrap">
                                                                <h3 class="field_name_h3" v-text="item.field_name"></h3>
                                                                <span class="applicable_products"
                                                                      v-text="item.extend.applicable_products==='all'?'（全部产品）':item.extend.applicable_products==='sale'?'（销售产品）':'（租借产品）'"></span>
                                                            </div>
                                                            <div class="flex_wrap">
                                                                <el-tooltip content="编辑"
                                                                            effect="dark"
                                                                            placement="top">
                                                                <span class="handle_icon_wrap"
                                                                      @click="handleClickEditAmountItem(item)">
                                                                    <i class="iconfont icon-bianji"></i>
                                                                </span>
                                                                </el-tooltip>
                                                                <el-tooltip :content="item.status==0?'停用':'启用'"
                                                                            effect="dark"
                                                                            placement="top">
                                                                <span class="handle_icon_wrap"
                                                                      @click="handleClickCheckIsUpper(item)">
                                                                    <i :class="item.status==0?'icon-tingyong':'icon-a-bingji3'"
                                                                       class="iconfont"></i>
                                                                </span>
                                                                </el-tooltip>
                                                                <el-tooltip content="删除"
                                                                            effect="dark"
                                                                            placement="top">
                                                                <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                                      @click="handleClickDelAmountItem(item,index)">
                                                                    <i class="iconfont icon-shanchu1"></i>
                                                                </span>
                                                                </el-tooltip>
                                                            </div>
                                                        </div>
                                                        <div class="formula_text"
                                                             v-text="item.extend.filling_method==='1'?item.extend.formula:'手动输入'"></div>
                                                    </li>
                                                </draggable>
                                            </ul>
                                            <div class="add_amount_information_btn"
                                                 @click="handleClickAddAmountInformation">
                                                <i class="el-icon-plus"></i>
                                                <span>新增金额</span>
                                            </div>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='purchase_details'">
                                            <el-form-item label="标题" prop="field_name">
                                                <el-input v-model="componentPropertyForm.field_name"
                                                          disabled></el-input>
                                            </el-form-item>
                                            <div class="purchase_details_list">
                                                <div class="little_hint">选择后在入库时可自动带入仓库，可修改</div>
                                                <div class="purchase_details_item">
                                                    <el-checkbox :value="true" disabled>采购产品</el-checkbox>
                                                </div>
                                                <div class="purchase_details_item">
                                                    <el-checkbox :value="true" disabled>数量</el-checkbox>
                                                </div>
                                                <div class="purchase_details_item">
                                                    <el-checkbox :value="true" disabled>单价</el-checkbox>
                                                </div>
                                                <div class="purchase_details_item">
                                                    <el-checkbox :value="true" disabled>小计金额</el-checkbox>
                                                </div>
                                                <div class="purchase_details_item">
                                                    <el-checkbox
                                                            :value="componentPropertyForm.extend.show_field.indexOf('note') > -1"
                                                            @change="handleChangeToggleField('note')">说明
                                                    </el-checkbox>
                                                </div>
                                                <div class="purchase_details_item">
                                                    <el-checkbox
                                                            :value="componentPropertyForm.extend.show_field.indexOf('stock') > -1"
                                                            @change="handleChangeToggleField('stock')">入库仓库
                                                    </el-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_key==='pay_total_price'">
                                            <el-form-item label="公式" prop="formula">
                                                <el-input
                                                        ref="formula_input"
                                                        v-model="componentPropertyForm.extend.formula"
                                                        placeholder="计算公式="
                                                        readonly
                                                        @focus="handleFormulaInputFocus">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="金额格式">
                                                <el-checkbox-group
                                                        v-model="componentPropertyForm.extend.format"
                                                        class="property_checkbox_group">
                                                    <el-checkbox label="1">显示大写数字（仅限人民币币种）</el-checkbox>
                                                    <el-checkbox label="2">显示千位分隔符</el-checkbox>
                                                    <el-checkbox label="3">
                                                        显示
                                                        <el-input-number v-model="componentPropertyForm.extend.some"
                                                                         :controls="false"
                                                                         :max="6"
                                                                         :min="0"
                                                                         size="mini"
                                                                         style="width: 60px">
                                                        </el-input-number>
                                                        位小数位数
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='radio_workorder_type'">
                                            <el-form-item label="选项" prop="workorder_types">
                                                <ul class="extend_options_list">
                                                    <li v-for="(item,index) in componentPropertyForm.extend.options"
                                                        :key="item.id"
                                                        class="extend_options_item">
                                                        <div class="input_radio_wrap">
                                                            <el-input v-model="item.name"
                                                                      maxlength="30"
                                                                      placeholder="请输入选项名称"
                                                                      size="mini"
                                                                      @blur="handleWorkorderTypeInputBlur"></el-input>
                                                        </div>
                                                        <i class="iconfont icon-guanbi_dise"
                                                           @click="handleClickDelExtendOptions(index)"></i>
                                                    </li>
                                                </ul>
                                                <el-button icon="el-icon-plus"
                                                           size="small"
                                                           type="text"
                                                           @click="handleClickAddExtendOptions">添加选项
                                                </el-button>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div v-else class="system_field_can_not_edit">
                                        该系统字段不允许编辑 ！
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="componentPropertyForm.field_type==='control'">
                                        <div v-if="componentPropertyForm.field_key==='control_payable'">
                                            <el-form-item label="应付金额填写方式">
                                                <el-radio-group
                                                        v-model="getChildField('payable_amount',componentPropertyForm).extend.filling_method"
                                                        class="property_radio_group"
                                                        @change="handleFillingMethodChange">
                                                    <el-radio label="2">手动录入</el-radio>
                                                    <el-radio label="1" style="margin-bottom: 0">自动计算</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item
                                                    v-if="getChildField('payable_amount',componentPropertyForm).extend.filling_method==='1'"
                                                    label="公式"
                                                    prop="formula">
                                                <el-input ref="formula_input"
                                                          v-model="getChildField('payable_amount',componentPropertyForm).extend.formula"
                                                          placeholder="计算公式="
                                                          @focus="handleFormulaInputFocus">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="币种" prop="currency">
                                                <el-select
                                                        v-model="getChildField('payable_amount',componentPropertyForm).extend.currency"
                                                        multiple
                                                        placeholder="请选择币种">
                                                    <el-option key="CNY" label="CNY-人民币（元）" value="CNY"></el-option>
                                                    <el-option key="USD" label="USD-美元（$）" value="USD"></el-option>
                                                </el-select>
                                                <p class="hint">选择多币种后，提交人可在选择范围内自选</p>
                                            </el-form-item>
                                            <el-form-item label="金额格式">
                                                <el-checkbox-group
                                                        v-model="getChildField('payable_amount',componentPropertyForm).extend.format"
                                                        class="property_checkbox_group">
                                                    <el-checkbox label="1">显示大写数字（仅限人民币币种）</el-checkbox>
                                                    <el-checkbox label="2">显示千位分隔符</el-checkbox>
                                                    <el-checkbox label="3">
                                                        显示
                                                        <el-input-number
                                                                v-model="getChildField('payable_amount',componentPropertyForm).extend.some"
                                                                :controls="false"
                                                                :max="6"
                                                                :min="0"
                                                                size="mini"
                                                                style="width: 60px">
                                                        </el-input-number>
                                                        位小数位数
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item>
                                                <div class="flex_wrap">
                                                    <el-switch v-model="componentPropertyForm.extend.payment_type_show"
                                                               @change="handleCheckPaymentTypeShow"></el-switch>
                                                    <span>付款类别</span>
                                                </div>
                                                <p class="hint">开启后，可以设置并告知相关人员如何收款</p>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_key==='control_rest'"
                                             style="position: relative">
                                            <el-form-item>
                                                <div slot="label" class="flex_js_wrap" style="width: 100%">
                                                    <span>当前假期类型</span>
                                                    <el-button type="text"
                                                               @click="handleClickGoToModify('rest')">前往修改
                                                    </el-button>
                                                </div>
                                                <vxe-table :data="holidayRules">
                                                    <vxe-table-column field="name" title="假期类型"></vxe-table-column>
                                                    <vxe-table-column title="请假时长单位" width="120">
                                                        <template #default="{row}">
                                                            <span v-text="row.time_unit==='day'?'天':'小时'"></span>
                                                        </template>
                                                    </vxe-table-column>
                                                    <vxe-table-column title="余额规则">
                                                        <template #default="{row}">
                                                            <span v-text="row.balance_rule === 1 ? '限额':'不限额'"></span>
                                                        </template>
                                                    </vxe-table-column>
                                                </vxe-table>
                                                <div class="explain_box">
                                                    根据考勤管理中配置的假期类型进行计算/录入，请假数将自动同步至考勤报表
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="">
                                                <div class="flex_wrap">
                                                    <el-switch
                                                            v-model="componentPropertyForm.extend.is_time_limited_submit"
                                                            active-color="#2990ff"
                                                            inactive-color="#999999"></el-switch>
                                                    <span>限时提交</span>
                                                </div>
                                                <p class="hint">开启后，可设置需在请假开始时间几天前提交/几天后补交</p>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.is_time_limited_submit"
                                                          :label="timeLimitedChangeText">
                                                <el-slider v-model="componentPropertyForm.extend.time_limited"
                                                           :marks="sliderMarks"
                                                           :max="30"
                                                           :min="-30"></el-slider>
                                            </el-form-item>
                                            <el-form-item label="字段设置">
                                                <el-checkbox v-for="item in fieldSiteList"
                                                             v-model="item.is_checked"
                                                             @change="handleCheckFieldShow($event,item)">
                                                    {{ item.field_name }}
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_key==='control_overtime'">
                                            <el-form-item label="">
                                                <div slot="label" class="flex_js_wrap" style="width: 100%">
                                                    <span>关于加班规则</span>
                                                    <el-button type="text"
                                                               @click="handleClickGoToModify('overtime')">前往修改
                                                    </el-button>
                                                </div>
                                                <div class="hint">
                                                    加班类型：根据加班规则自动判断加班类型和时长最小计时单位可在加班规则中修改
                                                </div>
                                                <div class="explain_box">加班数据将自动同步至考勤记录表</div>
                                            </el-form-item>
                                            <el-form-item label="">
                                                <div class="flex_wrap">
                                                    <el-switch
                                                            v-model="componentPropertyForm.extend.is_time_limited_submit"
                                                            active-color="#2990ff"
                                                            inactive-color="#999999"></el-switch>
                                                    <span>限时提交</span>
                                                </div>
                                                <p class="hint">开启后，可设置需在加班开始时间几天前提交/几天后补交</p>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.is_time_limited_submit"
                                                          :label="timeLimitedChangeText">
                                                <el-slider v-model="componentPropertyForm.extend.time_limited"
                                                           :marks="sliderMarks"
                                                           :max="30"
                                                           :min="-30"></el-slider>
                                            </el-form-item>
                                            <el-form-item label="字段设置">
                                                <el-checkbox v-for="item in fieldSiteList"
                                                             v-model="item.is_checked"
                                                             @change="handleCheckFieldShow($event,item)">
                                                    {{ item.field_name }}
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_key==='control_travel'">
                                            <el-form-item label="出差行程">
                                                <div class="hint">时长：根据自然日计算，提交人应精准至上午/下午</div>
                                                <div class="hint">交通工具：飞机、火车、高铁/动车、汽车、船、其他</div>
                                                <div class="hint">单程/往返：单程或往返</div>
                                                <div class="explain_box">
                                                    出差总时长：自动计算，审批通过后自动同步至考勤记录表
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="">
                                                <el-switch
                                                        v-model="getChildField('travel_stroke_group',componentPropertyForm).extend.is_many_stroke_submit"
                                                        active-color="#2990ff"
                                                        inactive-color="#999999"
                                                        @change="handleManyStrokeSubmitChange"></el-switch>
                                                <span>允许添加多行程</span>
                                                <p class="hint">开启后，将允许提交人添加多条详细出差行程</p>
                                            </el-form-item>
                                            <el-form-item>
                                                <div class="flex_wrap">
                                                    <el-switch
                                                            v-model="componentPropertyForm.extend.is_time_limited_submit"
                                                            active-color="#2990ff"
                                                            inactive-color="#999999"></el-switch>
                                                    <span>限时提交</span>
                                                </div>
                                                <p class="hint">开启后，可设置需在出差开始时间几天前提交/几天后补交</p>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.is_time_limited_submit"
                                                          :label="timeLimitedChangeText">
                                                <el-slider v-model="componentPropertyForm.extend.time_limited"
                                                           :marks="sliderMarks"
                                                           :max="30"
                                                           :min="-30"></el-slider>
                                            </el-form-item>
                                            <el-form-item label="字段设置">
                                                <el-checkbox v-for="item in fieldSiteList"
                                                             v-model="item.is_checked"
                                                             style="display: inline-block"
                                                             @change="handleCheckFieldShow($event,item)">
                                                    {{ item.field_name }}
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <el-form-item
                                                :label="componentPropertyForm.field_type==='form_module'?'分组标题':'标题'"
                                                prop="field_name">
                                            <el-input v-model="componentPropertyForm.field_name"
                                                      :maxlength="componentPropertyForm.field_type==='form_module'?'12':'10'"
                                                      :placeholder="componentPropertyForm.field_type==='form_module'?'请输入分组标题':'请输入标题'"
                                                      :disabled="componentPropertyForm.field_type == 'workorder_role' && componentPropertyForm.extend.relate_role_type === 'assign_user'"
                                                      @blur="handlePropertyFormFieldNameInputBlur"></el-input>
                                        </el-form-item>
                                        <el-form-item v-if="componentPropertyForm.extend.hasOwnProperty('placeholder')"
                                                      label="默认提示">
                                            <el-input v-model="componentPropertyForm.extend.placeholder"
                                                      maxlength="20"
                                                      placeholder="请输入默认提示">
                                            </el-input>
                                        </el-form-item>
                                        <div v-if="componentPropertyForm.field_type==='input'">
                                            <el-form-item label="字段类型" prop="input_type">
                                                <el-radio-group v-model="componentPropertyForm.extend.input_type"
                                                                class="property_radio_group">
                                                    <el-radio label="text">标准文本</el-radio>
                                                    <el-radio label="email">邮箱格式</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item v-if="fieldIsUniqueShow">
                                                <el-switch v-model="componentPropertyForm.is_unique"
                                                           :active-value="1"
                                                           :inactive-value="0"
                                                           active-color="#2990ff"
                                                           active-text="数据唯一性"
                                                           inactive-color="#999999">
                                                </el-switch>
                                                <div class="hint">开启后，该控件填写的内容会跟数据库对比，数据不会重复
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <el-form-item v-else-if="componentPropertyForm.field_type==='explain'"
                                                      label="说明内容"
                                                      prop="explain">
                                            <el-input v-model="componentPropertyForm.extend.explain"
                                                      :rows="6"
                                                      placeholder="请输入说明内容"
                                                      type="textarea">
                                            </el-input>
                                        </el-form-item>
                                        <div v-else-if="componentPropertyForm.field_type==='number'">
                                            <el-form-item label="单位" prop="unit">
                                                <el-input v-model="componentPropertyForm.extend.unit"
                                                          maxlength="4"
                                                          placeholder="请输入单位">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="设置数值范围">
                                                <div class="count_scope_wrap">
                                                    <el-input-number v-model="componentPropertyForm.extend.min"
                                                                     :controls="false"
                                                                     :max="componentPropertyForm.extend.max - 1"
                                                                     placeholder="最小数值">
                                                    </el-input-number>
                                                    <el-input-number v-model="componentPropertyForm.extend.max"
                                                                     :controls="false"
                                                                     :min="componentPropertyForm.extend.min + 1"
                                                                     placeholder="最大数值">
                                                    </el-input-number>
                                                </div>
                                                <div class="hint">设置后填写的数值范围需在填写范围内</div>
                                            </el-form-item>
                                            <el-form-item label="其他可选">
                                                <el-checkbox-group v-model="componentPropertyForm.extend.other_site"
                                                                   class="property_checkbox_group">
                                                    <el-checkbox label="1">整数</el-checkbox>
                                                    <el-checkbox label="2">正数</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='money'">
                                            <el-form-item label="币种" prop="currency">
                                                <el-select
                                                        v-model="componentPropertyForm.extend.currency"
                                                        multiple
                                                        placeholder="请选择币种">
                                                    <el-option key="CNY" label="CNY-人民币（元）" value="CNY"></el-option>
                                                    <el-option key="USD" label="USD-美元（$）" value="USD"></el-option>
                                                </el-select>
                                                <p class="hint">选择多币种后，提交人可在选择范围内自选</p>
                                            </el-form-item>
                                            <el-form-item label="金额格式">
                                                <el-checkbox-group
                                                        v-model="componentPropertyForm.extend.format"
                                                        class="property_checkbox_group">
                                                    <el-checkbox label="1">显示大写数字（仅限人民币币种）</el-checkbox>
                                                    <el-checkbox label="2">显示千位分隔符</el-checkbox>
                                                    <el-checkbox label="3">
                                                        显示
                                                        <el-input-number v-model="componentPropertyForm.extend.some"
                                                                         :controls="false"
                                                                         :max="6"
                                                                         :min="0"
                                                                         size="mini"
                                                                         style="width: 60px">
                                                        </el-input-number>
                                                        位小数位数
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="设置金额范围">
                                                <div class="count_scope_wrap">
                                                    <el-input-number v-model="componentPropertyForm.extend.min"
                                                                     :controls="false"
                                                                     :max="componentPropertyForm.extend.max - 1"
                                                                     placeholder="最小数值"
                                                                     style="width: 180px">
                                                    </el-input-number>
                                                    <el-input-number v-model="componentPropertyForm.extend.max"
                                                                     :controls="false"
                                                                     :min="componentPropertyForm.extend.min + 1"
                                                                     placeholder="最大数值"
                                                                     style="width: 180px">
                                                    </el-input-number>
                                                </div>
                                                <div class="hint">设置后填写的数值范围需在填写范围内</div>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='compute_mode'">
                                            <el-form-item label="公式" prop="formula">
                                                <el-input
                                                        ref="formula_input"
                                                        v-model="componentPropertyForm.extend.formula"
                                                        placeholder="计算公式="
                                                        readonly
                                                        @focus="handleFormulaInputFocus">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="金额格式">
                                                <el-checkbox-group
                                                        v-model="componentPropertyForm.extend.format"
                                                        class="property_checkbox_group">
                                                    <el-checkbox label="1">显示大写数字（仅限人民币币种）</el-checkbox>
                                                    <el-checkbox label="2">显示千位分隔符</el-checkbox>
                                                    <el-checkbox label="3">
                                                        显示
                                                        <el-input-number v-model="componentPropertyForm.extend.some"
                                                                         :controls="false"
                                                                         :max="6"
                                                                         :min="0"
                                                                         size="mini"
                                                                         style="width: 60px">
                                                        </el-input-number>
                                                        位小数位数
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='telephone'">
                                            <el-form-item label="电话类型">
                                                <el-radio-group v-model="componentPropertyForm.extend.phone_type"
                                                                class="property_radio_group">
                                                    <el-radio label="1">仅支持手机号码</el-radio>
                                                    <el-radio label="2">仅支持固定号码</el-radio>
                                                    <el-radio label="3">支持手机号码和固定号码</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-switch v-model="componentPropertyForm.extend.direct_dial"
                                                           active-color="#2990ff"
                                                           active-text="直接拨打"
                                                           inactive-color="#999999">
                                                </el-switch>
                                                <p class="hint">开启后，可在手机端直接点击号码拨打电话</p>
                                            </el-form-item>
                                            <el-form-item v-if="fieldIsUniqueShow">
                                                <el-switch v-model="componentPropertyForm.is_unique"
                                                           :active-value="1"
                                                           :inactive-value="0"
                                                           active-color="#2990ff"
                                                           active-text="数据唯一性"
                                                           inactive-color="#999999">
                                                </el-switch>
                                                <div class="hint">开启后，该控件填写的内容会跟数据库对比，数据不会重复
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='radio'">
                                            <el-form-item prop="extend.options">
                                                <span slot="label" class="label_btn_wrap">
                                                    <span>选项</span>
                                                    <el-button size="mini"
                                                               type="text"
                                                               @click="handleQuickAddOption">快捷添加</el-button>
                                                </span>
                                                <ul class="extend_options_list">
                                                    <draggable v-model="componentPropertyForm.extend.options"
                                                               :animation="300"
                                                               :forceFallback="true"
                                                               handle=".icon-a-move">
                                                        <li v-for="(item,index) in componentPropertyForm.extend.options"
                                                            :key="item.value"
                                                            class="extend_options_item">
                                                            <i class="iconfont icon-a-move"></i>
                                                            <div class="input_radio_wrap">
                                                                <el-input v-model="item.label"
                                                                          maxlength="30"
                                                                          placeholder="请输入选项名"
                                                                          size="mini"
                                                                          @blur="handleOptionInputBlur(item)"></el-input>
                                                                <div :class="{'is_active':item.default}"
                                                                     class="is_defaut_wrap"
                                                                     @click="handleClickDefaultOption(item)">
                                                                    <span class="radio_span"></span>
                                                                    <span class="radio_text">设为默认</span>
                                                                </div>
                                                            </div>
                                                            <i class="iconfont icon-guanbi_dise"
                                                               @click="handleClickDelExtendOptions(index)"></i>
                                                        </li>
                                                    </draggable>
                                                </ul>
                                                <el-button icon="el-icon-plus"
                                                           size="small"
                                                           type="text"
                                                           @click="handleClickAddExtendOptions">添加选项
                                                </el-button>
                                            </el-form-item>
                                            <el-form-item label="其他可选">
                                                <div class="tag_interaction_wrap">
                                                    <el-checkbox v-model="componentPropertyForm.extend.tag_interaction">
                                                        开启标签交互模式
                                                    </el-checkbox>
                                                    <el-popover :visible-arrow="false"
                                                                placement="top"
                                                                popper-class="extend_option_popover"
                                                                title=""
                                                                trigger="hover">
                                                    <span slot="reference" class="handle_icon_wrap">
                                                        <i class="iconfont icon-yiwen"></i>
                                                    </span>
                                                        <ul class="tag_interaction_label_list">
                                                            <li class="tag_interaction_label_item">标签样式</li>
                                                            <li class="tag_interaction_label_item">普通样式</li>
                                                        </ul>
                                                        <ul class="tag_interaction_value_list border_bottom">
                                                            <li class="tag_interaction_value_item"><span
                                                                    class="tag_span">销售经理</span></li>
                                                            <li class="tag_interaction_value_item">销售经理</li>
                                                        </ul>
                                                        <ul class="tag_interaction_value_list">
                                                            <li class="tag_interaction_value_item"><span
                                                                    class="tag_span">销售专员</span></li>
                                                            <li class="tag_interaction_value_item">销售专员</li>
                                                        </ul>
                                                    </el-popover>
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='checkbox'">
                                            <el-form-item prop="extend.options">
                                                <span slot="label" class="label_btn_wrap">
                                            <span>选项</span>
                                            <el-button size="mini"
                                                       type="text"
                                                       @click="handleQuickAddOption">快捷添加</el-button>
                                        </span>
                                                <ul class="extend_options_list">
                                                    <draggable v-model="componentPropertyForm.extend.options"
                                                               :animation="300"
                                                               :forceFallback="true"
                                                               handle=".icon-a-move">
                                                        <li v-for="(item,index) in componentPropertyForm.extend.options"
                                                            :key="item.value"
                                                            class="extend_options_item">
                                                            <i class="iconfont icon-a-move"></i>
                                                            <div class="input_radio_wrap">
                                                                <el-input v-model="item.label"
                                                                          maxlength="30"
                                                                          placeholder="请输入选项名"
                                                                          size="mini"
                                                                          @blur="handleOptionInputBlur(item)"></el-input>
                                                            </div>
                                                            <i class="iconfont icon-guanbi_dise"
                                                               @click="handleClickDelExtendOptions(index)"></i>
                                                        </li>
                                                    </draggable>
                                                </ul>
                                                <el-button icon="el-icon-plus"
                                                           size="small"
                                                           type="text"
                                                           @click="handleClickAddExtendOptions">添加选项
                                                </el-button>
                                            </el-form-item>
                                            <el-form-item label="其他可选">
                                                <div class="tag_interaction_wrap">
                                                    <el-checkbox v-model="componentPropertyForm.extend.tag_interaction">
                                                        开启标签交互模式
                                                    </el-checkbox>
                                                    <el-popover :visible-arrow="false"
                                                                placement="top"
                                                                popper-class="extend_option_popover"
                                                                title=""
                                                                trigger="hover">
                                            <span slot="reference" class="handle_icon_wrap">
                                                <i class="iconfont icon-yiwen"></i>
                                            </span>
                                                        <ul class="tag_interaction_label_list">
                                                            <li class="tag_interaction_label_item">标签样式</li>
                                                            <li class="tag_interaction_label_item">普通样式</li>
                                                        </ul>
                                                        <ul class="tag_interaction_value_list border_bottom">
                                                            <li class="tag_interaction_value_item"><span
                                                                    class="tag_span">销售经理</span></li>
                                                            <li class="tag_interaction_value_item">销售经理</li>
                                                        </ul>
                                                        <ul class="tag_interaction_value_list">
                                                            <li class="tag_interaction_value_item"><span
                                                                    class="tag_span">销售专员</span></li>
                                                            <li class="tag_interaction_value_item">销售专员</li>
                                                        </ul>
                                                    </el-popover>
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='cascader'">
                                            <el-form-item label="分类录入" prop="extend.cascader_options">
                                                <ul class="extend_options_list">
                                                    <draggable v-model="componentPropertyForm.extend.options"
                                                               :animation="300"
                                                               :forceFallback="true"
                                                               handle=".icon-a-move">
                                                        <li v-for="(item,index) in componentPropertyForm.extend.options"
                                                            :key="item.value"
                                                            class="mb_12">
                                                            <div class="extend_options_item">
                                                                <i class="iconfont icon-a-move"></i>
                                                                <div class="input_radio_wrap">
                                                                    <el-input v-model="item.label"
                                                                              maxlength="10"
                                                                              placeholder="请输入选项名"
                                                                              size="mini"
                                                                              @blur="handleCascaderOptionsBlur"></el-input>
                                                                </div>
                                                                <span class="handle_icon_wrap"
                                                                      @click="handleClickAddCascaderExtendOptions(item)">
                                                                <i class="iconfont icon-fenlei_jilian"></i>
                                                            </span>
                                                                <span class="handle_icon_wrap"
                                                                      @click="handleClickDelCascaderExtendOptions(componentPropertyForm.extend.options,index)">
                                                                        <i class="iconfont icon-guanbi_dise"></i>
                                                                    </span>
                                                            </div>
                                                            <ul class="extend_options_list pl_24">
                                                                <draggable v-model="item._child"
                                                                           :animation="300"
                                                                           :forceFallback="true"
                                                                           handle=".icon-a-move">
                                                                    <li v-for="(child,child_index) in item._child"
                                                                        :key="child.value"
                                                                        class="mb_12">
                                                                        <div class="extend_options_item">
                                                                            <i class="iconfont icon-a-move"></i>
                                                                            <div class="input_radio_wrap">
                                                                                <el-input v-model="child.label"
                                                                                          maxlength="10"
                                                                                          placeholder="请输入选项名"
                                                                                          size="mini"
                                                                                          @blur="handleCascaderOptionsBlur"></el-input>
                                                                            </div>
                                                                            <span class="handle_icon_wrap"
                                                                                  @click="handleClickAddCascaderExtendOptions(child)">
                                                                            <i class="iconfont icon-fenlei_jilian"></i>
                                                                        </span>
                                                                            <span class="handle_icon_wrap"
                                                                                  @click="handleClickDelCascaderExtendOptions(item._child,child_index,item)">
                                                                            <i class="iconfont icon-guanbi_dise"></i>
                                                                        </span>
                                                                        </div>
                                                                        <ul class="extend_options_list pl_24">
                                                                            <draggable v-model="child._child"
                                                                                       :animation="300"
                                                                                       :forceFallback="true"
                                                                                       handle=".icon-a-move">
                                                                                <li v-for="(grandson,grandson_index) in child._child"
                                                                                    :key="grandson.value"
                                                                                    class="mb_12">
                                                                                    <div class="extend_options_item">
                                                                                        <i class="iconfont icon-a-move"></i>
                                                                                        <div class="input_radio_wrap">
                                                                                            <el-input
                                                                                                    v-model="grandson.label"
                                                                                                    maxlength="10"
                                                                                                    placeholder="请输入选项名"
                                                                                                    size="mini"
                                                                                                    @blur="handleCascaderOptionsBlur"></el-input>
                                                                                        </div>
                                                                                        <span class="handle_icon_wrap">
                                                                                <i class="iconfont icon-fenlei_jilian is_disabled"></i>
                                                                            </span>
                                                                                        <span class="handle_icon_wrap"
                                                                                              @click="handleClickDelCascaderExtendOptions(child._child,grandson_index,child)">
                                                                                            <i class="iconfont icon-guanbi_dise"></i>
                                                                                        </span>
                                                                                    </div>
                                                                                </li>
                                                                            </draggable>
                                                                        </ul>
                                                                    </li>
                                                                </draggable>
                                                            </ul>
                                                        </li>
                                                    </draggable>
                                                </ul>
                                                <div class="add_extend_options_btn"
                                                     @click="handleClickAddExtendOptions">
                                                    <i class="el-icon-plus"></i>添加选项
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='date'">
                                            <el-form-item label="日期类型" prop="date_type">
                                                <el-radio-group
                                                        v-model="componentPropertyForm.extend.date_type"
                                                        class="property_radio_group">
                                                    <el-radio label="year-month">_年_月</el-radio>
                                                    <el-radio label="date">_年_月_日</el-radio>
                                                    <el-radio label="time">时:分</el-radio>
                                                    <el-radio label="datetime">_年_月_日 时:分</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item label="默认时间">
                                                <el-checkbox v-model="componentPropertyForm.extend.default">赋值当前时间
                                                </el-checkbox>
                                            </el-form-item>
                                            <el-form-item v-if="!componentPropertyForm.extend.default"
                                                          label="可选择时间范围">
                                                <el-radio-group v-model="componentPropertyForm.extend.time_range"
                                                                class="property_radio_group">
                                                    <el-radio label="any">任意时间</el-radio>
                                                    <el-radio label="before">当前时间之前</el-radio>
                                                    <el-radio label="after">当前时间之后</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='date_range'">
                                            <el-form-item label="默认提示1">
                                                <el-input v-model="componentPropertyForm.extend.start_placeholder"
                                                          maxlength="20">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="默认提示2">
                                                <el-input v-model="componentPropertyForm.extend.end_placeholder"
                                                          maxlength="20">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="日期类型" prop="date_type">
                                                <el-radio-group v-model="componentPropertyForm.extend.date_type"
                                                                @change="handleDateRangeDateTypeChange"
                                                                class="property_radio_group">
                                                    <el-radio label="daterange">_年_月_日</el-radio>
                                                    <el-radio label="timerange">时:分</el-radio>
                                                    <el-radio label="datetimerange">_年_月_日 时:分</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <div v-if="componentPropertyForm.extend.date_type!=='timerange'">
                                                <el-form-item>
                                                    <el-switch v-model="componentPropertyForm.extend.auto_computed"
                                                               active-color="#2990ff"
                                                               active-text="时长"
                                                               inactive-color="#999999"
                                                               @change="handleAutoComputedChange">
                                                    </el-switch>
                                                    <p class="hint">选择开始结束时间后自动计算时长</p>
                                                </el-form-item>
                                                <el-form-item v-if="componentPropertyForm.extend.auto_computed">
                                                    <el-radio-group
                                                            v-model="componentPropertyForm.extend.compute_mode"
                                                            class="property_radio_group">
                                                        <el-radio label="1">计算自然时长</el-radio>
                                                        <el-radio label="2">计算工作时长（会自动扣除休息日）</el-radio>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </div>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='address'">
                                            <el-form-item label="地区精度" prop="area_accuracy">
                                                <el-radio-group v-model="componentPropertyForm.extend.area_accuracy"
                                                                class="property_radio_group"
                                                                @change="handleAreaAccuracyChange">
                                                    <el-radio label="1">省-市-区/县</el-radio>
                                                    <el-radio label="2">省-市</el-radio>
                                                    <el-radio label="3">国家-地区</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item label="地区精度默认提示">
                                                <el-input
                                                        v-model="componentPropertyForm.extend.area_accuracy_placeholder"
                                                        maxlength="20"
                                                        placeholder="请输入地区精度默认提示">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-switch
                                                        v-model="componentPropertyForm.extend.is_show_detail_address"
                                                        active-color="#2990ff"
                                                        active-text="详细地址"
                                                        inactive-color="#999999"
                                                        @change="handleShowDetailAddressChange">
                                                </el-switch>
                                                <p class="hint">开启后，该控件增加详细地址输入框</p>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.is_show_detail_address"
                                                          label="详细地址默认提示">
                                                <el-input
                                                        v-model="componentPropertyForm.extend.detail_address_placeholder"
                                                        maxlength="20"
                                                        placeholder="请输入详细地址默认提示">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.is_show_detail_address">
                                                <el-checkbox
                                                        v-model="componentPropertyForm.extend.detail_address_is_required">
                                                    详细地址必填
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='location'">
                                            <el-form-item label="允许手动修改">
                                                <el-switch v-model="componentPropertyForm.extend.allow_manual_edit"
                                                           active-color="#1990ff"
                                                           inactive-color="#999999">
                                                </el-switch>
                                                <p class="hint">开启后，支持对定位地址的手动修改</p>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='contact'">
                                            <el-form-item label="选择范围">
                                                <el-checkbox-group v-model="componentPropertyForm.extend.select_range"
                                                                   class="property_checkbox_group">
                                                    <el-checkbox label="1">可选多人</el-checkbox>
                                                    <el-checkbox label="2">可选自己</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="">
                                                <el-switch v-model="componentPropertyForm.extend.default"
                                                           active-color="#2990ff"
                                                           active-text="默认人员"
                                                           inactive-color="#999999">
                                                </el-switch>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.default">
                                                <el-radio-group v-model="componentPropertyForm.extend.default_can_edit"
                                                                class="property_radio_group">
                                                    <el-radio label="1">提交人（允许修改）</el-radio>
                                                    <el-radio label="2">提交人（不允许修改）</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='workorder_role'">
                                            <el-form-item label="关联角色" prop="relate_role_id">
                                                <el-select v-model="componentPropertyForm.extend.relate_role_id"
                                                           placeholder="请选择关联角色"
                                                           @focus="handleRelateRolesSelectFocus">
                                                    <el-option v-for="item in relateRolesList"
                                                               :label="item.role_name"
                                                               :value="item.id"
                                                               @click.native="handleRelateRoleSelectChange(item)"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="说明">
                                                <el-input v-model="componentPropertyForm.extend.remarks"
                                                          :rows="4"
                                                          placeholder="设置的说明，在发起时会在该字段下方提示"
                                                          type="textarea"></el-input>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='department'">
                                            <el-form-item label="选择范围">
                                                <el-radio-group v-model="componentPropertyForm.extend.select_range"
                                                                class="property_radio_group">
                                                    <el-radio label="1">可选单个部门</el-radio>
                                                    <el-radio label="2">可选多个部门</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <el-form-item label="">
                                                <div class="flex_wrap">
                                                    <el-switch v-model="componentPropertyForm.extend.default"
                                                               active-color="#2990FF"
                                                               inactive-color="#999999"></el-switch>
                                                    <span>默认部门</span>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.default">
                                                <el-radio-group v-model="componentPropertyForm.extend.default_can_edit"
                                                                class="property_radio_group">
                                                    <el-radio label="1">提交人部门（允许修改）</el-radio>
                                                    <el-radio label="2">提交人部门（不允许修改）</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='file'">
                                            <el-form-item label="示例文件">
                                                <p class="hint">
                                                    上传示例文件，提交人可以下载并根据示例内容进行文件上传</p>
                                                <div v-if="Object.keys(componentPropertyForm.extend.sample_file).length===0"
                                                     class="upload_sample_file_btn"
                                                     @click="handleUploadSampleFile">
                                                    <i class="iconfont icon-upload"></i>上传
                                                </div>
                                                <div v-else class="sample_file_wrap">
                                                    <div class="file_name"
                                                         v-text="componentPropertyForm.extend.sample_file.file_name"></div>
                                                    <div>
                                                        <el-tooltip content="预览"
                                                                    effect="dark"
                                                                    placement="top">
                                                            <span class="handle_icon_wrap"
                                                                  @click="handleClickPreviewSampleFile(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                                        </el-tooltip>
                                                        <span class="line"></span>
                                                        <el-tooltip content="删除"
                                                                    effect="dark"
                                                                    placement="top">
                                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                                  @click="handleClickDelSampleFile">
                                                                <i class="iconfont icon-shanchu1"></i>
                                                            </span>
                                                        </el-tooltip>
                                                    </div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="附件类型" prop="file_type">
                                                <el-input v-model="componentPropertyForm.extend.file_type"
                                                          placeholder="请输入附件类型"></el-input>
                                                <p class="hint">提交人只能上传输入的附件类型，多个类型用、分隔</p>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='table'">
                                            <el-form-item
                                                    v-if="field_form!=='projects'&&field_form!=='project_stage_tasks'&&field_form!=='orders'"
                                                    label="填写方式">
                                                <el-radio-group v-model="componentPropertyForm.extend.filling_method"
                                                                class="property_radio_group">
                                                    <el-radio label="horizontal">
                                                        横向
                                                        <el-popover placement="top"
                                                                    trigger="hover">
                                                            <span slot="reference" class="handle_icon_wrap">
                                                                <i class="iconfont icon-yiwen"></i>
                                                            </span>
                                                            <img alt=""
                                                                 src=" https://download.hecoos.com/enlightv/2025-10/16a1e8878333c9e5287a90893a731546.png"
                                                                 width="286">
                                                        </el-popover>
                                                    </el-radio>
                                                    <el-radio
                                                            v-if="!cannotSetTableVerticalFieldFrom.includes(field_form)"
                                                            label="vertical">
                                                        纵向
                                                        <el-popover placement="top" trigger="hover">
                                                            <span slot="reference" class="handle_icon_wrap">
                                                                <i class="iconfont icon-yiwen"></i>
                                                            </span>
                                                            <img alt=""
                                                                 src="https://download.hecoos.com/enlightv/2025-11/c95ea60fcd73f46f3db1bbe8dd8c87c0.png"
                                                                 width="286">
                                                        </el-popover>
                                                    </el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                            <!--                                        <el-form-item>
                                                                                        <el-switch v-model="componentPropertyForm.extend.import_by_template"
                                                                                                   active-text="通过模板导入"></el-switch>
                                                                                        <p class="hint">开启后，支持只能支持单行文本、多行文本、数字、金额控件，适用于批量添加产品，如采购等场景对定位地址的手动修改</p>
                                                                                    </el-form-item>-->
                                            <el-form-item class="error_msg_display_none"
                                                          prop="table_length"></el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='checkbox_approval'">
                                            <el-form-item label="" prop="optional_range">
                                                <div class="flex_wrap">
                                                    <el-switch v-model="componentPropertyForm.extend.optional_range"
                                                               active-color="#1990ff"
                                                               inactive-color="#999999"
                                                               @change="handleOptionalRangeChange">
                                                    </el-switch>
                                                    <span>配置可选范围</span>
                                                </div>
                                                <p class="hint">开启后，提交人只能关联以下范围内的审批</p>
                                            </el-form-item>
                                            <div class="E8E8E8_line"></div>
                                            <el-form-item v-if="componentPropertyForm.extend.optional_range"
                                                          label="审批单类型"
                                                          prop="approve_form_scope">
                                                <el-select v-model="componentPropertyForm.extend.approve_form_scope"
                                                           collapse-tags
                                                           filterable
                                                           multiple
                                                           placeholder="请选择审批单类型">
                                                    <el-option v-for="type in approvalTypeList"
                                                               :key="type.approval_set_id"
                                                               :label="type.name"
                                                               :value="type.approval_set_id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="" prop="relate_approved">
                                                <div class="flex_wrap">
                                                    <el-switch v-model="componentPropertyForm.extend.relate_approved"
                                                               active-color="#2990ff"
                                                               inactive-color="#999999"></el-switch>
                                                    <span>仅可关联审批通过的单据</span>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="" prop="not_promoter_self">
                                                <div class="flex_wrap">
                                                    <el-switch v-model="componentPropertyForm.extend.not_promoter_self"
                                                               active-color="#1990ff"
                                                               inactive-color="#999999"
                                                               @change="handleNotPromoterSelfChange">
                                                    </el-switch>
                                                    <span>可关联发起人非本人的单据</span>
                                                </div>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.not_promoter_self"
                                                          prop="self_in_approval_process_node">
                                                <el-checkbox
                                                        v-model="componentPropertyForm.extend.self_in_approval_process_node">
                                                    本人在审批流节点上
                                                </el-checkbox>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='checkbox_check_record'">
                                            <el-form-item label="" prop="optional_range">
                                                <el-switch v-model="componentPropertyForm.extend.addition_of_multiple"
                                                           active-color="#2990FF"
                                                           inactive-color="#999999"></el-switch>
                                                <span>允许添加多个打卡记录</span>
                                            </el-form-item>
                                            <el-form-item label="" prop="optional_range">
                                                <div class="flex_wrap">
                                                    <el-switch
                                                            v-model="componentPropertyForm.extend.mobile_devices_directly"
                                                            active-color="#2990FF"
                                                            inactive-color="#999999">
                                                    </el-switch>
                                                    <span>移动端可直接打卡</span>
                                                </div>
                                                <div class="hint_text">
                                                    开关为开时，在移动端可直接在此控件处打卡（仅支持单次打卡）
                                                </div>
                                            </el-form-item>
                                        </div>
                                        <el-form-item v-else-if="componentPropertyForm.field_type==='paying_teller'"
                                                      label="添加账户字段设置">
                                            <div class="field_site_wrap">
                                                <el-switch v-model="componentPropertyForm.extend.bank_branch_is_show"
                                                           active-color="#2990ff"
                                                           active-text="银行支行"
                                                           inactive-color="#999999"
                                                           size="samll"></el-switch>
                                                <el-checkbox
                                                        v-model="componentPropertyForm.extend.bank_branch_is_required">
                                                    必填
                                                </el-checkbox>
                                            </div>
                                        </el-form-item>
                                        <el-form-item v-else-if="componentPropertyForm.field_type==='rate'"
                                                      label="评分制">
                                            <el-radio-group
                                                    v-model="componentPropertyForm.extend.point_system"
                                                    class="property_radio_group">
                                                <el-radio label="5">5分制</el-radio>
                                                <el-radio label="10">10分制</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <div v-else-if="componentPropertyForm.field_type==='id_card'">
                                            <el-form-item prop="upload_recognition">
                                                <el-switch v-model="componentPropertyForm.extend.upload_recognition"
                                                           active-color="#2990ff"
                                                           active-text="证件上传识别"
                                                           inactive-color="#999999">
                                                </el-switch>
                                                <p class="hint">开启后，支持上传证件照片自动识别内容</p>
                                            </el-form-item>
                                            <el-form-item v-if="componentPropertyForm.extend.upload_recognition"
                                                          label="控制字段设置">
                                                <ul>
                                                    <li class="field_site_wrap">
                                                        <el-switch v-model="componentPropertyForm.extend.name_is_show"
                                                                   active-color="#2990ff"
                                                                   active-text="姓名"
                                                                   inactive-color="#999999">
                                                        </el-switch>
                                                        <el-checkbox
                                                                v-model="componentPropertyForm.extend.name_is_required">
                                                            必填
                                                        </el-checkbox>
                                                    </li>
                                                    <li class="field_site_wrap">
                                                        <el-switch
                                                                v-model="componentPropertyForm.extend.birthday_is_show"
                                                                active-color="#2990ff"
                                                                active-text="出生日期"
                                                                inactive-color="#999999">
                                                        </el-switch>
                                                        <el-checkbox
                                                                v-model="componentPropertyForm.extend.birthday_is_required">
                                                            必填
                                                        </el-checkbox>
                                                    </li>
                                                    <li class="field_site_wrap">
                                                        <el-switch
                                                                v-model="componentPropertyForm.extend.address_is_show"
                                                                active-color="#2990ff"
                                                                active-text="家庭住址"
                                                                inactive-color="#999999">
                                                        </el-switch>
                                                        <el-checkbox
                                                                v-model="componentPropertyForm.extend.address_is_required">
                                                            必填
                                                        </el-checkbox>
                                                    </li>
                                                </ul>
                                            </el-form-item>
                                            <el-form-item prop="data_desensitization">
                                                <el-switch v-model="componentPropertyForm.extend.data_desensitization"
                                                           active-color="#2990ff"
                                                           active-text="数据脱敏"
                                                           inactive-color="#999999">
                                                </el-switch>
                                                <p class="hint">展示时隐藏敏感信息，如2312************21</p>
                                                <p class="hint">点击「显示」展示全部信息</p>
                                            </el-form-item>
                                        </div>
                                        <div v-else-if="componentPropertyForm.field_type==='invoice'">
                                            <el-form-item label="发票比对信息设置"
                                                          prop="extend.comparison_info_setting">
                                                <p class="hint">
                                                    上传的发票将自动识别并与设置的信息比对，确认发票是否正确</p>
                                                <ul>
                                                    <li v-for="(item,index) in componentPropertyForm.extend.comparison_info_setting"
                                                        :key="index"
                                                        class="comparison_info_item">
                                                        <el-form
                                                                :ref="'comparison_info_form_reimbursement_charge_details_'+componentPropertyForm.field_key+'_'+index"
                                                                :model="item"
                                                                :rules="comparisonInfoFormRules"
                                                                label-position="top"
                                                                size="mini">
                                                            <el-form-item label="名称" prop="purchaser_name">
                                                                <el-input v-model="item.purchaser_name"
                                                                          placeholder="请输入名称"></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="纳税人识别号"
                                                                          prop="purchaser_tax_number">
                                                                <el-input v-model="item.purchaser_tax_number"
                                                                          placeholder="请输入纳税人识别号"></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="地址、电话"
                                                                          prop="purchaser_contact_info">
                                                                <el-input v-model="item.purchaser_contact_info"
                                                                          placeholder="请输入地址、电话"></el-input>
                                                            </el-form-item>
                                                            <el-form-item label="开户行及账号"
                                                                          prop="purchaser_bank_account_info">
                                                                <el-input v-model="item.purchaser_bank_account_info"
                                                                          placeholder="请输入开户行及账号"></el-input>
                                                            </el-form-item>
                                                        </el-form>
                                                        <i class="el-icon-remove"
                                                           @click="handleClickDeleteSetting(index)"></i>
                                                    </li>
                                                </ul>
                                                <el-button icon="el-icon-plus"
                                                           type="text"
                                                           @click="handleClickAddSetting">添加设置
                                                </el-button>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="field_form==='users'&&componentPropertyForm.extend.hasOwnProperty('is_form_show')"
                                     class="is_form_show_wrap">
                                    <el-switch v-model="componentPropertyForm.extend.is_form_show"
                                               :disabled="componentPropertyForm.is_system === 1"
                                               active-text="在入职登记表显示"></el-switch>
                                </div>
                            </div>
                            <div v-else>
                                <el-form-item class="rules_set_form">
                                    <div slot="label">
                                        <span>显示条件设置</span>
                                        <el-popover placement="bottom"
                                                    popper-class="example_popover"
                                                    title="请选择控制此控件显隐的其他控件并录入控制条件"
                                                    trigger="hover"
                                                    width="340">
                                            <i slot="reference" class="iconfont icon-shuoming"></i>
                                            <div class="popover_content_wrap">
                                                <h4>示例：</h4>
                                                <div class="example_box">
                                                    <div>
                                                        <p style="color: #333333;font-weight: 500;line-height: 22px">
                                                            当</p>
                                                        <p style="color: #666666;line-height: 22px">请假类型</p>
                                                        <p style="line-height: 22px"><span
                                                                style="color: #999999">选择</span>
                                                        </p>
                                                        <p style="line-height: 22px"><span
                                                                style="color: #999999">事假</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                    <p class="hint">符合以下条件显示该控件</p>
                                    <ul class="condition_group_list">
                                        <li v-for="(item,index) in componentPropertyForm.rules" :key="index"
                                            class="condition_group_item">
                                            <div class="condition_group_title_wrap">
                                                <span class="condition_group_title">条件组</span>
                                                <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                      @click="handleClickDelConditionGroup(index)">
                                                <i class="el-icon-close"></i>
                                            </span>
                                            </div>
                                            <ul class="condition_list">
                                                <li v-for="(child,child_index) in item" :key="child_index"
                                                    class="condition_item">
                                                    <div class="condition_item_title_wrap">
                                                        <span v-text="child_index>0?'且':'当'"></span>
                                                        <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                              @click="handleClickDelCondition(child_index,item,index)">
                                                        <i class="el-icon-delete"></i>
                                                    </span>
                                                    </div>
                                                    <el-form
                                                            :ref="componentPropertyForm.field_key+'_'+componentPropertyForm.field_type+'_condition_form_group'+''+index+'_'+child_index"
                                                            :model="child"
                                                            :rules="conditionFormRules"
                                                            size="small">
                                                        <el-form-item prop="field_key">
                                                            <el-select
                                                                    v-model="child.field_key"
                                                                    placeholder="请选择作为条件的控件"
                                                                    @change="handleSelectConditionFieldChange($event,child,item)"
                                                                    @focus="getConditionFieldList">
                                                                <el-option v-for="field in conditionFieldList"
                                                                           :key="field.field_key"
                                                                           :label="field.field_name"
                                                                           :value="field.field_key">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item prop="operator">
                                                            <el-select v-model="child.operator"
                                                                       placeholder="请选择条件">
                                                                <el-option
                                                                        v-for="operator in getOperatorSelectList(child)"
                                                                        :label="operator.label"
                                                                        :value="operator.value">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item v-if="conditionFieldList[child.field_key]"
                                                                      prop="field_value">
                                                            <div v-if="conditionFieldList[child.field_key].condition_type==='options'">
                                                                <el-select
                                                                        v-if="conditionFieldList[child.field_key].field_key==='holiday_rule_id'"
                                                                        v-model="child.field_value"
                                                                        :multiple="conditionFieldList[child.field_key].field_type==='checkbox'"
                                                                        placeholder="请选择指标"
                                                                        @focus="handleSelectFieldValueFocus(child)">
                                                                    <el-option v-for="radio in holidayRules"
                                                                               :label="radio.holiday_type_config_name"
                                                                               :value="radio.id">
                                                                    </el-option>
                                                                </el-select>
                                                                <el-select
                                                                        v-else-if="conditionFieldList[child.field_key].field_key==='overtime_rule_id'"
                                                                        v-model="child.field_value"
                                                                        :multiple="conditionFieldList[child.field_key].field_type==='checkbox'"
                                                                        placeholder="请选择指标"
                                                                        @focus="handleSelectFieldValueFocus(child)">
                                                                    <el-option label="加班费" value="1"></el-option>
                                                                    <el-option label="调休假" value="2"></el-option>
                                                                </el-select>
                                                                <el-select
                                                                        v-else
                                                                        v-model="child.field_value"
                                                                        :multiple="conditionFieldList[child.field_key].field_type==='checkbox'"
                                                                        placeholder="请选择指标">
                                                                    <el-option
                                                                            v-for="radio in conditionFieldList[child.field_key].extend.options"
                                                                            :label="radio.label"
                                                                            :value="radio.value">
                                                                    </el-option>
                                                                </el-select>
                                                            </div>
                                                            <el-input-number
                                                                    v-else-if="conditionFieldList[child.field_key].condition_type==='number'"
                                                                    v-model="child.field_value"
                                                                    :controls="false"
                                                                    :precision="2"
                                                                    placeholder="请输入指标">
                                                            </el-input-number>
                                                            <div v-else-if="conditionFieldList[child.field_key].condition_type==='date'">
                                                                <el-select v-model="child.field_value.value"
                                                                           placeholder="请选择指标">
                                                                    <el-option label="当前时间" value="1"></el-option>
                                                                    <el-option label="自主选择时间"
                                                                               value="2"></el-option>
                                                                </el-select>
                                                                <div v-if="child.field_value.value==='2'"
                                                                     style="margin-top: 12px">
                                                                    <el-date-picker
                                                                            v-if="conditionFieldList[child.field_key].extend.date_type==='year-month'"
                                                                            v-model="child.field_value.date"
                                                                            :editable="false"
                                                                            format="yyyy-MM"
                                                                            placeholder="请选择指标"
                                                                            type="month"
                                                                            value-format="yyyy-MM">
                                                                    </el-date-picker>
                                                                    <el-date-picker
                                                                            v-else-if="conditionFieldList[child.field_key].extend.date_type==='date'"
                                                                            v-model="child.field_value.date"
                                                                            :editable="false"
                                                                            format="yyyy-MM-dd"
                                                                            placeholder="请选择指标"
                                                                            type="date"
                                                                            value-format="yyyy-MM-dd">
                                                                    </el-date-picker>
                                                                    <el-time-picker
                                                                            v-else-if="conditionFieldList[child.field_key].extend.date_type==='time'"
                                                                            v-model="child.field_value.date"
                                                                            :editable="false"
                                                                            format="HH:mm"
                                                                            placeholder="请选择指标"
                                                                            value-format="HH:mm">
                                                                    </el-time-picker>
                                                                    <el-date-picker
                                                                            v-else-if="conditionFieldList[child.field_key].extend.date_type==='datetime'"
                                                                            v-model="child.field_value.date"
                                                                            :editable="false"
                                                                            format="yyyy-MM-dd HH:mm"
                                                                            placeholder="请选择指标"
                                                                            type="datetime"
                                                                            value-format="yyyy-MM-dd HH:mm">
                                                                    </el-date-picker>
                                                                </div>
                                                            </div>
                                                            <el-select
                                                                    v-else-if="conditionFieldList[child.field_key].condition_type==='department'"
                                                                    v-model.trim="child.field_value.titles"
                                                                    :popper-append-to-body="false"
                                                                    clearable
                                                                    collapse-tags
                                                                    multiple
                                                                    placeholder="请选择指标"
                                                                    @clear="handleClickClearDepartment(child,index+ '_' +child_index)"
                                                                    @focus="handleDepartmentFocus(child,index+ '_' + child_index)"
                                                                    @remove-tag="handleClickRemoveDepartment($event,child,index+ '_' + child_index)">
                                                                <el-option :value="[]" style="height: auto;padding: 0">
                                                                    <el-tree
                                                                            :ref="'department' + index + '_' + child_index"
                                                                            :data="depOptions"
                                                                            :expand-on-click-node='false'
                                                                            :props="{children: 'children',label: 'relate_name'}"
                                                                            check-on-click-node
                                                                            check-strictly
                                                                            default-expand-all
                                                                            highlight-current
                                                                            node-key="relate_id"
                                                                            show-checkbox
                                                                            size="mini"
                                                                            @check-change="(data,checked,indeterminate)=>handleDepartmentCheckChange(data,checked,indeterminate,child)">
                                                                    </el-tree>
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                    </el-form>
                                                </li>
                                                <el-link :underline="false"
                                                         type="primary"
                                                         @click="handleClickAddCondition(item)">
                                                    <i class="el-icon-plus"></i>添加条件
                                                </el-link>
                                            </ul>
                                            <div v-if="index != componentPropertyForm.rules.length-1" class="either">或
                                            </div>
                                        </li>
                                    </ul>
                                    <el-link v-if="Object.keys(conditionFieldList).length>0"
                                             :underline="false"
                                             type="primary"
                                             @click="handleClickAddConditionGroup">
                                        <i class="el-icon-plus"></i>添加条件组
                                    </el-link>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <FormulaEditForm v-if="formulaEditDialogShow"
                         :components_list="components_list"
                         :dialogVisible.sync="formulaEditDialogShow"
                         :field_form="field_form"
                         :now_field_key="componentPropertyForm.field_key"
                         :formula_list="nowFieldFormulaList"
                         @confirm="formulaEditFormConfirm"/>
        <el-dialog v-if="quickAddOptionDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="quickAddOptionDialog"
                   title="快捷添加"
                   width="520px"
                   @close="handleClickQuickAddOptionCancel">
            <p class="quick_add_option_hint">不同选项请换行处理</p>
            <el-input v-model="quickAddOptionText"
                      :rows="10"
                      maxlength="200"
                      placeholder="请输入选项"
                      resize="none"
                      show-word-limit
                      type="textarea"></el-input>
            <div slot="footer">
                <el-button size="small" @click="handleClickQuickAddOptionCancel">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickQuickAddOptionConfirm">确定</el-button>
            </div>
        </el-dialog>
        <ReviewFormDialog v-if="reviewFormDialog"
                          :dialogVisible.sync="reviewFormDialog"
                          :formInfoList="formInfoList"
                          :review_dialog_width="review_dialog_width"
                          :review_form_type_list="review_form_type_list"/>
        <el-dialog v-if="amountInformationDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :title="amount_field_key?'编辑金额':'新建金额'"
                   :visible.sync="amountInformationDialog"
                   width="621px"
                   @close="handleClickAmountInformationCancel">
            <el-form ref="amountInformationForm"
                     :model="amountInformationForm"
                     :rules="amountInformationFormRules"
                     label-position="top"
                     label-width="auto"
                     size="small">
                <el-form-item label="金额名称" prop="field_name">
                    <el-input v-model="amountInformationForm.field_name" maxlength="12"
                              placeholder="请输入金额名称"></el-input>
                </el-form-item>
                <el-form-item label="适用产品" prop="applicable_products">
                    <span slot="label">
                        <span>适用产品</span>
                        <span class="hint">（该金额仅计算所选产品的金额）</span>
                    </span>
                    <el-radio-group v-model="amountInformationForm.applicable_products">
                        <el-radio label="all">全部</el-radio>
                        <el-radio label="sale">销售产品</el-radio>
                        <el-radio label="lease">租借产品</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="金额计算方式" prop="filling_method">
                    <el-radio-group v-model="amountInformationForm.filling_method" @change="handleFillingMethodChange">
                        <el-radio label="1">计算公式算出</el-radio>
                        <el-radio label="2">手动填写</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="amountInformationForm.filling_method==='1'" label="计算公式" prop="formula">
                    <el-input v-model="amountInformationForm.formula"
                              placeholder="点击配置公式"
                              readonly
                              @focus="handleAmountFormulaInputFocus"></el-input>
                </el-form-item>
                <el-form-item label="数值显示样式" prop="num_display_style">
                    <el-radio-group v-model="amountInformationForm.num_display_style">
                        <el-radio label="1">数字模式</el-radio>
                        <el-radio label="2">百分比模式</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" prop="visible_person_range">
                    <div slot="label" class="flex_js_wrap">
                        <span>可见范围</span>
                        <el-tooltip content="仅已选的人员或部门可以查看该金额，不选默认全员可见"
                                    effect="dark"
                                    placement="top">
                                <span class="handle_icon_wrap">
                                    <i class="iconfont icon-yiwen"></i>
                                </span>
                        </el-tooltip>
                    </div>
                    <el-select v-model="visiblePersonRangeNames"
                               class="department_user_select"
                               clearable
                               collapse-tags
                               multiple
                               placeholder="点击配置人员"
                               readonly
                               suffix-icon="el-icon-arrow-down"
                               popper-class="selectPopperHideClass"
                               @focus="handleVisiblePersonInputFocus"
                               @remove-tag="handleRemoveVisiblePersonTag">
                    </el-select>
                </el-form-item>
                <el-form-item label="作为计算数值" prop="as_calculated_val">
                    <el-switch v-model="amountInformationForm.as_calculated_val"></el-switch>
                    <span v-text="amountInformationForm.as_calculated_val?'开启':'关闭'"></span>
                    <p class="little_hint">开关开启后，可作为其他金额公式配置中的基础数值，用于其他金额的计算</p>
                </el-form-item>
            </el-form>
            <div slot="footer" align="right">
                <el-button :disabled="btnDisabled" size="small" @click="handleClickAmountInformationCancel">取消
                </el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary"
                           @click="handleClickAmountInformationConfirm">确定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="formulaEditVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   class="formula_edit_dialog"
                   :visible.sync="formulaEditVisible"
                   title="计算公式配置"
                   width="680px">
            <el-form ref="fieldForm"
                     :model="formulaForm"
                     label-position="top"
                     size="small"
                     @submit.native.prevent>
                <el-form-item label="公式预览">
                    <div class="textarea_outer_wrap">
                        <span class="placeholder">计算公式=</span>
                        <div ref="textarea_div"
                             class="textarea_wrap"
                             contenteditable
                             @input="handleTextareaInput"
                             @keydown="handleTextareaKeyDown">
                        </div>
                        <img alt="" class="delete_btn"
                             src="https://download.hecoos.com/enlightv/2023-31/WXCTpjXDpzGnejYZe2tY.png"
                             @click="handleClickDel">
                        <span class="clear_btn" @click="handleClickClearFormula">清空</span>
                    </div>
                    <p class="little_hint">数字可直接输入，计算逻辑要符合计算规则</p>
                </el-form-item>
                <el-form-item label="符号">
                    <ul class="components_list">
                        <li v-for="item in symbolList"
                            class="components_item"
                            @click="handleClickSymbolItem(item)"
                            v-text="item.value">
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item label="系统数值">
                    <ul class="components_list">
                        <li class="components_item" @click="handleClickSystemComponentsItem('product_cost')">产品成本
                        </li>
                        <li class="components_item" @click="handleClickSystemComponentsItem('product_total_price')">产品总价
                        </li>
                        <li class="components_item"
                            @click="handleClickSystemComponentsItem('total_price')">订单总金额
                        </li>
                        <li class="components_item"
                            @click="handleClickSystemComponentsItem('purchase_price')">代采成本
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item v-if="basicValueList.length" label="自定义数值">
                    <ul class="components_list">
                        <li v-for="item in basicValueList"
                            :key="item.field_key"
                            class="components_item"
                            @click="handleClickComponentsItem(item)"
                            v-text="item.new_field_name">
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item
                        v-if="getCommodityValueConfig('product_cost').length || getCommodityValueConfig('product_total_price').length"
                        label="自定义数值">
                    <div slot="label">
                        <div>商品相关数值配置<span
                                class="little_hint">（支持自定义选择特定的产品参与计算，不选择时默认为全部产品）</span>
                        </div>
                    </div>
                    <ul>
                        <li v-for="item in getCommodityValueConfig('product_cost')"
                            :key="item.field_key"
                            class="value_config_item">
                            <el-input v-if="item.is_edit"
                                      v-model="item.content"
                                      maxlength="10"
                                      placeholder="请输入名称"
                                      size="mini"
                                      @blur="handleContentNameBlur(item,'product_cost')"
                                      @keyup.enter.native="handleContentNameEnter(item,'product_cost')">
                            </el-input>
                            <div v-else class="value_config_name">
                                <span class="config_name" v-text="item.content"></span>
                                <span class="handle_icon_wrap" @click="handleClickEditContentName(item)">
                                    <i class="iconfont icon-bianji"></i>
                                </span>
                            </div>
                            <el-link :underline="false" type="primary" @click="handleClickGoodsConfig(item)">配置产品
                            </el-link>
                        </li>
                        <li v-for="item in getCommodityValueConfig('product_total_price')"
                            :key="item.field_key"
                            class="value_config_item">
                            <el-input v-if="item.is_edit"
                                      v-model="item.content"
                                      maxlength="10"
                                      placeholder="请输入名称"
                                      size="mini"
                                      @blur="handleContentNameBlur(item,'product_total_price')"
                                      @keyup.enter.native="handleContentNameEnter(item,'product_total_price')">
                            </el-input>
                            <div v-else class="value_config_name">
                                <span class="config_name" v-text="item.content"></span>
                                <span class="handle_icon_wrap" @click="handleClickEditContentName(item)">
                                    <i class="iconfont icon-bianji"></i>
                                </span>
                            </div>
                            <el-link :underline="false" type="primary" @click="handleClickGoodsConfig(item)">配置产品
                            </el-link>
                        </li>
                    </ul>
                </el-form-item>
            </el-form>
            <div slot="footer" align="right">
                <el-button size="small" @click="handleClickFormulaEditCancel">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickFormulaEditConfirm">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="visiblePersonDialogVisible"
                   :before-close="handleClickVisiblePersonCancel"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="visiblePersonDialogVisible"
                   custom-class="option_dialog"
                   title="可见人员配置"
                   width="700px">
            <div v-loading="depUserLoading" class="department_user_wrap">
                <div class="left_selectable_wrap">
                    <div class="title_wrap">
                        <div :class="{'active':select_type==='1'}" class="type_title" @click="select_type='1'">角色
                        </div>
                        <div :class="{'active':select_type==='2'}" class="type_title" @click="select_type='2'">指定人员
                        </div>
                    </div>
                    <div class="selectable_wrap">
                        <div v-show="select_type==='1'" class="select_type_1_wrap">
                            <el-checkbox v-model="order_creator" @change="handleClickOrderCreator">订单负责人
                            </el-checkbox>
                            <el-checkbox v-model="order_approver" @change="handleClickOrderApprover">订单审批人
                            </el-checkbox>
                        </div>
                        <div v-show="select_type==='2'" style="height: 100%">
                            <el-input v-model="depUserKeyWord"
                                      placeholder="请输入员工姓名"
                                      size="small"
                                      @input="getDepartmentAndUserList">
                                <i slot="suffix" class="el-icon-search" @click="getDepartmentAndUserList"></i>
                            </el-input>
                            <div class="scroll_wrap">
                                <el-tree ref="departUserTree"
                                         :data="departmentUserList"
                                         :default-expanded-keys="[]"
                                         :expand-on-click-node='false'
                                         :props="{children: 'children',label: 'relate_name'}"
                                         check-on-click-node
                                         check-strictly
                                         node-key="relate_type_id"
                                         show-checkbox
                                         @check="handleCheckUserNodeItem">
                                </el-tree>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_selected_wrap">
                    <div class="title_wrap">
                        <div class="selected_count">
                            <span class="text">已选</span>
                            <span v-if="selectedDepUserList.length"
                                  class="count"
                                  v-text="selectedDepUserList.length"></span>
                        </div>
                        <div class="clear_btn" @click="handleClickClearSelectedUser">清除</div>
                    </div>
                    <ul class="selected_list">
                        <li v-for="(item,index) in selectedDepUserList"
                            :key="item.uid"
                            class="selected_item">
                            <span v-text="item.name"></span>
                            <i class="el-icon-error" @click="handleClickDelSelectedUser(item, index)"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickVisiblePersonCancel">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickVisiblePersonConfirm">确定</el-button>
            </div>
        </el-dialog>
        <SelectProductDialog v-if="selectProductsVisible"
                             ref="select_product_dialog"
                             :dialogVisible.sync="selectProductsVisible"
                             @confirm="handleClickChooseGoodsConfirm"/>
        <el-image ref="preview_img"
                  :preview-src-list="previewImgList"
                  :src="previewImgSrc"
                  style="display:none">
        </el-image>
    </div>
</template>
<script>
import {
    checkFieldUsage,
    getCustomControls,
    GetDepartmentList,
    getFormFields,
    saveFormFields,
    GetDepartmentUserList,
    workOrderTypeList,
    workOrderTypeEdit,
    getControlGroupFields,
    GetHolidayRuleList,
    workOrderRoleList,
    getApprovalType,
    workOrderFormRoleDelCheck
} from "@/api";
import draggable from 'vuedraggable'
import FormulaEditForm from "@/components/pComponents/FormulaEditForm";
import SelectProductDialog from "@/components/pComponents/SelectProductDialog";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
import ReviewFormDialog from "@/components/pComponents/ReviewFormDialog";
import customField from "@/components/pComponents/customField";

import {componentsFilterRule} from "@/utils";
import {uploadImg} from "@/utils/uploadOss";

export default {
    name: "CustomFormSite",
    data() {
        return {
            controlOptionsList: [], //控件
            controlsOptionsList: [], //控件组
            fieldTableList: [], //表单组
            componentPropertyForm: {}, //表单属性表单
            componentPropertyFormRules: {
                field_name: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (!value) {
                            return callback(new Error(this.componentPropertyForm.field_type === 'form_module' ? '请输入分组标题' : '请输入标题'))
                        }
                        if (this.formInfoList.filter(item => item.field_name === value).length > 1) {
                            return callback(new Error('控件名称重复，请重新输入'))
                        }
                        if (this.componentPropertyForm.p_field_key) {
                            const p_field = this.formInfoList.find(item => item.field_key === this.componentPropertyForm.p_field_key)
                            if (p_field) {
                                if (p_field.field_type === 'form_module') {
                                    const list = []
                                    this.formInfoList.forEach(item => {
                                        if (item._child && item._child.length > 0) {
                                            item._child.forEach(child => {
                                                list.push(child)
                                            })
                                        }
                                    })
                                    if (list.filter(child => child.field_name === value).length > 1) return callback(new Error('控件名称重复，请重新输入'))
                                } else if (p_field.field_type === 'table') {
                                    this.formInfoList.forEach(item => {
                                        if (item._child && item._child.length && item._child.filter(child => child.field_name === value).length > 1) {
                                            return callback(new Error('控件名称重复，请重新输入'))
                                        }
                                    })
                                }
                            }
                        }
                        callback()
                    }
                }],
                explain: [{
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (!this.componentPropertyForm.extend.explain) return callback(new Error('请输入说明内容'))
                        callback()
                    }
                }],
                serial_number_rules: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (value.length === 0) {
                            return callback(new Error('请设置流水号规则'))
                        } else {
                            callback()
                        }
                    }
                }],
                formula: [{
                    required: true,
                    message: '请设置计算公式',
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm.field_type === 'compute_mode') {
                            if (!this.componentPropertyForm.extend.formula) return callback(new Error('请设置计算公式'))
                            callback()
                        } else if (this.componentPropertyForm.field_type === 'control') {
                            const payable_amount = this.getChildField('payable_amount', this.componentPropertyForm)
                            if (payable_amount && payable_amount.extend.filling_method === '1' && !payable_amount.extend.formula) return callback(new Error('请设置计算公式'))
                            callback()
                        }
                    }
                }],
                receipt_method: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.getChildField('reimbursement_payment_type', this.componentPropertyForm).receipt_method_site && this.receipt_method.length === 0) {
                            return callback(new Error('请选择收款方式'))
                        }
                        callback()
                    }
                }],
                approve_form_scope: [
                    {
                        required: true,
                        trigger: 'change',
                        validator: (rule, value, callback) => {
                            if (this.componentPropertyForm.extend.approve_form_scope.length === 0) return callback(new Error('请选择审批单类型'))
                            callback()
                        }
                    }],
                type_name_setting: [{required: true, message: '请输入类型名称', trigger: 'change',}],
                return_name_setting: [{required: true, message: '请输入归还名称', trigger: 'change',}],
                'extend.options': [{
                    required: true,
                    trigger: ['change', 'blur'],
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm.extend.options.length === 0) return callback(new Error('请添加选项'))
                        if (this.componentPropertyForm.extend.options.some(item => item.label === '')) return callback(new Error('请输入选项名'))
                        const hasDuplicates = this.componentPropertyForm.extend.options.filter((item, index) => {
                            return this.componentPropertyForm.extend.options.findIndex((element) => element.label === item.label) !== index;
                        }).length > 0;
                        if (hasDuplicates) {
                            return callback(new Error('选项名称重复，请重新输入'))
                        } else {
                            callback()
                        }
                    }
                }],
                workorder_types: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm.extend.options.length === 0) return callback(new Error('请添加工单类型'))
                        if (this.componentPropertyForm.extend.options.some(item => item.name === '')) return callback(new Error('请输入选项名称'))
                        const hasDuplicates = this.componentPropertyForm.extend.options.filter((item, index) => {
                            return this.componentPropertyForm.extend.options.findIndex((element) => element.name === item.name) !== index;
                        }).length > 0;
                        if (hasDuplicates) {
                            return callback(new Error('选项名称重复，请重新输入'))
                        } else {
                            callback()
                        }
                    }
                }],
                'extend.cascader_options': [{
                    required: true,
                    trigger: ['change', 'blur'],
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm.extend.options.length === 0) return callback(new Error('至少添加一个选项'))

                        //校验名称是否为空
                        function validateLabels(arr) {
                            for (let item of arr) {
                                // 检查当前项的 label 是否为空
                                if (!item.label) return false
                                // 如果存在 _child，递归检查子项
                                if (item._child && item._child.length > 0) {
                                    const childValidation = validateLabels(item._child);
                                    if (!childValidation) return false;
                                }
                            }
                            return true; // 所有 label 都不为空
                        }

                        // 递归检查所有选项的 label是否重复
                        function validateOptionData(data) {
                            function validateLabels(arr, parentLabel) {
                                const labelsMap = new Map();
                                for (const item of arr) {
                                    if (labelsMap.has(parentLabel)) {
                                        const labels = labelsMap.get(parentLabel);
                                        if (labels.has(item.label)) {
                                            return false;
                                        }
                                        labels.add(item.label);
                                    } else {
                                        labelsMap.set(parentLabel, new Set([item.label]));
                                    }
                                    if (item._child && !validateLabels(item._child, item.label)) {
                                        return false;
                                    }
                                }
                                return true;
                            }

                            return validateLabels(data, null);
                        }

                        if (!validateLabels(this.componentPropertyForm.extend.options)) return callback(new Error('请输入选项名'))
                        if (!validateOptionData(this.componentPropertyForm.extend.options)) return callback(new Error('选项名称重复，请重新输入'))
                        callback()
                    }
                }],
                currency: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm.field_key === 'control_payable') {
                            if (this.getChildField('payable_amount', this.componentPropertyForm).extend.currency.length === 0) return callback(new Error('请选择币种'))
                        } else {
                            if (this.componentPropertyForm.extend.currency.length === 0) return callback(new Error('请选择币种'))
                        }
                        callback()
                    }
                }],
                table_length: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm._child.length === 0) return callback(new Error('明细表格中必须添加控件'))
                        callback()
                    }
                }],
                relate_role_id: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (!this.componentPropertyForm.extend.relate_role_id) return callback(new Error('请选择关联角色'))
                        callback()
                    }
                }],
                "extend.comparison_info_setting": [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.componentPropertyForm.extend.comparison_info_setting.length === 0) {
                            callback()
                        } else {
                            let flag = true
                            this.componentPropertyForm.extend.comparison_info_setting.forEach((item, index) => {
                                this.$refs[`comparison_info_form_reimbursement_charge_details_${this.componentPropertyForm.field_key}_${index}`][0].validate(valid => {
                                    if (!valid) {
                                        flag = false
                                    }
                                })
                            })
                            if (!flag) {
                                callback(new Error('请完善对比信息'))
                            } else {
                                callback()
                            }
                        }
                    }
                }]
            },
            //表单属性表单校验规则
            basicSettingGroup: 'basic',
            basicSettingGroupFlag: 'basic',
            formInfoList: [],
            fieldKeyIndex: 1,
            loading: false,
            quote_form: [],
            btnDisabled: false,
            tempActiveData: {},
            components_list: [],
            formulaEditDialogShow: false,
            quickAddOptionDialog: false,
            quickAddOptionText: '',
            reviewFormDialog: false,
            reviewFormType: 'pc',
            reviewFormTitle: '',
            rateValue: 5,
            approvalTypeList: [],
            comparisonInfoFormRules: {
                purchaser_name: [{required: true, message: '请输入名称', trigger: 'blur'}],
                purchaser_tax_number: [{required: true, message: '请输入纳税人识别号', trigger: 'blur'}],
                purchaser_contact_info: [{required: true, message: '请输入地址、电话', trigger: 'blur'}],
                purchaser_bank_account_info: [{required: true, message: '请输入开户行及账号', trigger: 'blur'}],
            },
            conditionFieldList: {},
            conditionFormRules: {
                field_key: {required: true, message: '请选择作为条件的控件',},
                operator: {required: true, message: '请选择条件',},
                field_value: {required: true, message: '请输入/选择指标',},
            },
            depOptions: [],
            amountInformationDialog: false,
            amountInformationForm: {
                field_name: '',
                as_calculated_val: false,
                filling_method: '1',
                num_display_style: '1',
                visible_person_range: [],
                formula: '',
                field_formula: '',
                formula_list: [],
                some: 2,
                applicable_products: 'all'
            },
            amountInformationFormRules: {
                field_name: [{required: true, message: '请输入金额名称', trigger: 'blur'}],
                applicable_products: [{required: true, message: '请选择适用产品', trigger: 'change'},],
                filling_method: [{required: true, message: '请选择金额计算方式', trigger: 'change'},],
                num_display_style: [{required: true, message: '请选择显示方式', trigger: 'change'}],
                formula: [{required: true, message: '请设置计算公式', trigger: 'blur',}],
            },
            formulaEditVisible: false,
            basicValueList: [],
            formulaItems: [],
            formulaForm: {},
            symbolList: [
                {value: '+'},
                {value: '-'},
                {value: '*'},
                {value: '/'},
                {value: '('},
                {value: ')'},
            ],
            keyCodeList: [8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
            amount_field_key: '',
            depUserLoading: false,
            departmentUserList: [],
            selectedDepUserList: [],
            order_creator: false,
            order_approver: false,
            visiblePersonDialogVisible: false,
            select_type: '1',
            depUserKeyWord: '',
            selectProductsVisible: false,
            formulaData: {},
            cannotSetTableVerticalFieldFrom: ['workorders'],
            components_options_tab: 'controls',
            holidayRules: [],
            fieldSiteList: [],
            sliderMarks: {
                '-30': '-30',
                0: '0',
                30: '30',
            },
            relateRolesList: [],
            nowFieldFormulaList: [],
            previewImgList: [],
            previewImgSrc: '',
        }
    },
    components: {
        draggable,
        FormulaEditForm,
        SelectProductDialog,
        CustomFormPc,
        ReviewFormDialog,
        CustomFormMobile,
        customField
    },
    props: {
        //表单名称
        field_form: {
            type: String,
            default: () => ""
        },
        filter_field_type: {
            type: String,
            default: () => ""
        }, //表单参数
        //表单标题
        field_form_title: {
            type: String,
            default: () => ""
        },
        //表单描述
        field_form_desc: {
            type: String,
            default: () => ""
        },
        //是否有表单分组
        is_form_module: {
            type: Boolean,
            default: () => false
        },
        //是否展示显示规则
        can_set_show_rules: {
            type: Boolean,
            default: () => false
        },
        //是否展示预览按钮
        review_btn_show: {
            type: Boolean,
            default: () => false
        },
        //预览标题
        review_form_type_list: {
            type: Array,
            default: () => {
                return []
            }
        },
        //是否展示发布按钮
        publish_btn_show: {
            type: Boolean,
            default: () => false
        },
        //是否为两列布局
        is_two_column: {
            type: Boolean,
            default: () => false
        },
        //预览弹窗宽度
        review_dialog_width: {
            type: String,
            default: () => '680px'
        },
        //是否显示控件组
        is_show_control_group: {
            type: Boolean,
            default: () => false
        },
        source: {
            type: String,
            default: 'other'
        }
    },
    created() {
        this.getControlOptionsList()
    },
    computed: {
        visiblePersonRangeNames() {
            return this.amountInformationForm.visible_person_range.map(item => item.name) || []
        },
        //字段的数据唯一性设置是否显示
        fieldIsUniqueShow() {
            if (this.source === 'approve') return false
            if (this.componentPropertyForm.p_field_key === '') {
                return true
            } else {
                const p_field = this.formInfoList.find(item => item.field_key === this.componentPropertyForm.p_field_key)
                return p_field && p_field.field_type !== 'table'
            }
        },
        timeLimitedChangeText() {
            let text = '提前提交最晚当天'
            const {time_limited} = this.componentPropertyForm.extend
            if (time_limited > 0) {
                text = '可延后' + time_limited + '天补交'
            } else if (time_limited < 0) {
                text = '可提前' + Math.abs(time_limited) + '天提交'
            }
            return text
        },
    },
    mounted() {

    },
    methods: {
        //获取控件
        getControlOptionsList() {
            this.loading = true
            getCustomControls().then(res => {
                if (res.code === 200) {
                    const {control, controls, forms} = res.data
                    const filterTypes = this.source === 'approve' ? componentsFilterRule('approve') : componentsFilterRule(this.field_form)
                    if (filterTypes.length) {
                        this.controlOptionsList = control.filter(item => {
                            // 过滤条件：types数组中存在该对象的field_type属性值
                            if (item.types && item.types.length > 0) {
                                item.types = item.types.filter(type => filterTypes.includes(type.field_type));
                                return item.types.length > 0;
                            }
                            return false;
                        });
                    } else {
                        this.controlOptionsList = control
                    }
                    if (this.field_form !== 'workorders') {
                        this.controlOptionsList = this.controlOptionsList.map(group => {
                            return {
                                ...group,
                                types: group.types.filter(type => type.field_type !== 'workorder_role')
                            };
                        });
                    }
                    this.controlsOptionsList = controls
                    this.fieldTableList = forms
                    this._getFromFields()
                } else {
                    this.loading = false
                }
            })
        },

        //表单字段获取
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: this.field_form,
                filter_field_type: this.filter_field_type ? this.filter_field_type : undefined
            }).then(res => {
                if (res.code === 200) {
                    if (this.field_form === 'project_stage_tasks') {
                        this.formInfoList = res.data.filter(item => item.is_system !== 1)
                    } else {
                        this.formInfoList = res.data
                    }
                    if (this.formInfoList.length) {
                        this.componentPropertyForm = this.formInfoList[0]
                        this.$set(this.componentPropertyForm, 'extend', this.formInfoList[0].extend)
                        if (this.componentPropertyForm.field_type === 'control') {
                            this.components_options_tab = 'control_group'
                            if (this.componentPropertyForm.field_key === 'control_rest') {
                                this.loading = true
                                GetHolidayRuleList({
                                    page: 1,
                                    pageSize: 9999,
                                }).then(res => {
                                    if (res.code === 200) {
                                        this.holidayRules = res.data
                                    } else {

                                    }
                                    this.loading = false
                                })
                            }
                            this.fieldSiteList = []
                            if (this.componentPropertyForm._child && this.componentPropertyForm._child.length > 0) {
                                this.componentPropertyForm._child.forEach(child => {
                                    if (child.field_type === 'control_group') {
                                        child._child.forEach(grandson => {
                                            if (grandson.extend.hasOwnProperty('is_show_switch')) {
                                                this.fieldSiteList.push({
                                                    ...grandson,
                                                    is_checked: !grandson.extend.initial_display
                                                })
                                            }
                                        })
                                    }
                                    if (child.extend.is_show_switch) {
                                        this.fieldSiteList.push({
                                            ...child,
                                            is_checked: !child.extend.initial_display
                                        })
                                    }
                                })
                            }
                        } else {
                            this.components_options_tab = 'controls'
                            if (this.componentPropertyForm.field_type === 'checkbox_approval' && this.componentPropertyForm.extend.optional_range) {
                                this.getApprovalTypeList()
                            }
                        }
                        const field_key_arr = []
                        this.formInfoList.forEach(field => {
                            field_key_arr.push(field.field_id)
                            if (field.hasOwnProperty('_child') && field._child.length) {
                                field._child.forEach(child => {
                                    field_key_arr.push(child.field_id)
                                    if (child.hasOwnProperty('_child') && child._child.length) {
                                        child._child.forEach(grandson => {
                                            field_key_arr.push(grandson.field_id)
                                            if (grandson.hasOwnProperty('_child') && grandson._child.length) {
                                                grandson._child.forEach(great_grandson => {
                                                    field_key_arr.push(great_grandson.field_id)
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        })
                        if (field_key_arr.length > 0) {
                            this.fieldKeyIndex = Math.max(...field_key_arr) + 1 || 1
                        }
                        this.$emit('form-loading-change', true)
                        this.canSelectTableRules(true)
                    }
                } else {

                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        //克隆左侧的控件
        cloneComponent(origin) {
            const clone = this.deepClone(JSON.parse(JSON.stringify(origin)))
            clone.field_key = 'field_' + this.fieldKeyIndex
            clone.sort = this.formInfoList.length + 1
            clone.is_system = 0
            clone.quote_field_form = ''
            clone.quote_field_key = ''
            clone.is_system_key = 0
            clone.is_unique = 0
            clone.is_required = 0
            clone.status = 0
            clone.p_field_key = ''
            clone.rules = []
            if (this.field_form === 'users') {
                clone.extend.is_form_show = true
            }
            if (!this.is_two_column) {
                clone.extend.col_span = 24
            }
            if (clone.field_type === 'table') {
                clone._child = []
            }
            this.fieldKeyIndex++
            this.tempActiveData = clone
            return clone
        },

        //深度克隆
        deepClone(obj) {
            const result = {}
            for (const key in obj) {
                if (key !== 'icon' && key !== 'desc' && key !== 'example') {
                    result[key] = obj[key]
                }
                if (key === 'extend') {
                    result[key] = {}
                    for (const extendKey in obj[key]) {
                        result[key][extendKey] = obj[key][extendKey]
                    }
                }
            }
            return result
        },

        //选择左侧组件事件
        onDragComponentsChoose(e) {
            for (let refsKey in this.$refs) {
                if (refsKey.indexOf('Popover') > -1) {
                    this.$refs[refsKey][0].doClose()
                }
            }
        },

        onDragComponentsMove(e) {
            if (e.relatedContext && e.draggedContext.element && (e.draggedContext.element.field_type === 'table' || e.draggedContext.element.field_type === 'explain' || e.draggedContext.element.field_type === 'serial_number') && e.to.className === 'table_drag_wrapper') return false
        },

        //拖拽结束
        onDragComponentsEnd(obj) {
            if (obj.from !== obj.to) {
                this.assignSortAndSetProperties()
            }
        },

        //重新设置字段的sort
        assignSortAndSetProperties() {
            this.assignSortValue(this.formInfoList);
            if (this.$refs.componentPropertyForm) {
                this.$refs.componentPropertyForm.validate((valid, errors) => {
                    if (valid) {
                        if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                            this.validateComponentPropertyFormRules().then(isValid => {
                                if (isValid) {
                                    // 验证成功后的逻辑
                                    this.componentPropertyForm = this.tempActiveData;
                                    this.$set(this.componentPropertyForm, 'extend', this.tempActiveData.extend)
                                    this.basicSettingGroup = 'basic';
                                } else {
                                    // 验证失败后的逻辑
                                    this.dragValidateErrorNextHandle()
                                }
                            })
                        } else {
                            this.componentPropertyForm = this.tempActiveData;
                            this.$set(this.componentPropertyForm, 'extend', this.tempActiveData.extend)
                            this.basicSettingGroup = 'basic';
                        }
                    } else {
                        const firstErrorField = Object.keys(errors)[0]; // 获取第一个校验失败的字段
                        this.$message.error(errors[firstErrorField][0].message)
                        this.dragValidateErrorNextHandle()
                    }
                })
            } else {
                this.componentPropertyForm = this.tempActiveData;
                this.$set(this.componentPropertyForm, 'extend', this.tempActiveData.extend)
                this.basicSettingGroup = 'basic';
            }
        },

        //拖拽左侧组件时校验错误后续操作
        dragValidateErrorNextHandle(field) {
            if (this.tempActiveData.p_field_key) {
                const p_field = this.formInfoList.find(field => field.field_key === this.tempActiveData.p_field_key)
                p_field._child.splice(p_field._child.findIndex(child => child.field_key === this.tempActiveData.field_key), 1)
            } else {
                this.formInfoList.splice(this.formInfoList.findIndex(field => field.field_key === this.tempActiveData.field_key), 1)
            }
        },

        //点击左侧组件事件
        handleSelectControl(item) {
            const clone = this.cloneComponent(item)
            if (this.$refs.componentPropertyForm) {
                this.$refs.componentPropertyForm.validate((valid, errors) => {
                    if (valid) {
                        if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                            this.validateComponentPropertyFormRules().then(isValid => {
                                if (isValid) {
                                    // 验证成功后的逻辑
                                    this.tempActiveData = clone
                                    this.selectComponentNextHandle()
                                }
                            })
                        } else {
                            this.tempActiveData = clone
                            this.selectComponentNextHandle()
                        }
                    } else {
                        const firstErrorField = Object.keys(errors)[0]; // 获取第一个校验失败的字段
                        this.$message.error(errors[firstErrorField][0].message)
                    }
                })
            } else {
                if (!this.is_form_module) {
                    //如果不是分组则直接添加
                    this.formInfoList.push(this.tempActiveData)
                    this.assignSortValue(this.formInfoList)
                    this.componentPropertyForm = this.tempActiveData
                    this.$set(this.componentPropertyForm, 'extend', this.tempActiveData.extend)
                    this.basicSettingGroup = 'basic'
                }
            }
        },

        //点击选择左侧组件下一步操作
        selectComponentNextHandle() {
            //如果有分组
            if (this.is_form_module) {
                //先判断当前选择的组件类型
                if (this.componentPropertyForm.field_type === 'form_module') {
                    this.componentPropertyForm._child.push(this.tempActiveData)
                } else {
                    if (this.componentPropertyForm.p_field_key) {
                        this.formInfoList.find(field => field.field_key === this.componentPropertyForm.p_field_key)._child.push(this.tempActiveData)
                    }
                }
            } else {
                //如果不是分组则直接添加
                this.formInfoList.push(this.tempActiveData)
            }
            this.assignSortValue(this.formInfoList)
            this.componentPropertyForm = this.tempActiveData
            this.$set(this.componentPropertyForm, 'extend', this.tempActiveData.extend)
            this.basicSettingGroup = 'basic'
        },

        deepFormValidate(name) {
            const that = this
            return new Promise(function (resolve, reject) {
                if (that.$refs[name]) {
                    if (Array.isArray(that.$refs[name])) {
                        that.$refs[name][0].validate(valid => {
                            if (valid) {
                                resolve();
                            } else {
                                reject()
                            }
                        })
                    } else {
                        that.$refs[name].validate(valid => {
                            if (valid) {
                                resolve();
                            } else {
                                reject()
                            }
                        })
                    }
                } else {
                    resolve()
                }
            })
        },

        //点击左侧控件组事件
        handleSelectControlGroup(item) {
            if (item.hasOwnProperty('disabled') && !item.disabled) return false
            if (this.formInfoList.some(each => each.field_key === 'control_' + item.field_type)) return this.$message.error('一个表单中只能添加一个' + item.field_name + '控件组')
            if (item.field_type === 'rest' || item.field_type === 'overtime' || item.field_type === 'travel') {
                this.$emit('save-form-source', item.field_type)
            }
            if (item.field_type === 'rest' && this.holidayRules.length === 0) {
                GetHolidayRuleList({
                    page: 1,
                    pageSize: 9999,
                }).then(res => {
                    this.holidayRules = res.data
                })
            }
            getControlGroupFields({
                controls: item.field_type
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.length) {
                        const field = res.data.find(data => data.field_type === 'control') || {};
                        field.control_type = item.field_type
                        field.sort = this.formInfoList.length + 1;
                        field.field_id = '';
                        field.is_system = '0';
                        field.rules = []
                        this.fieldSiteList = []
                        if (field._child && field._child.length > 0) {
                            field._child.forEach(child => {
                                child.sort = field.sort
                                child.field_id = ''
                                if (child.field_type === 'control_group') {
                                    child._child.forEach(grandson => {
                                        grandson.field_id = ''
                                        grandson.sort = child.sort
                                        if (grandson.extend) {
                                            for (let extendKey in grandson.extend) {
                                                this.$set(grandson, extendKey, grandson.extend[extendKey])
                                            }
                                        }
                                        if (grandson.field_type == 'table') {
                                            grandson._child.forEach(great_grandson => {
                                                great_grandson.field_id = ''
                                                great_grandson.sort = field.sort
                                            })
                                        }
                                        if (grandson.extend.is_show_switch) {
                                            this.fieldSiteList.push({
                                                ...grandson,
                                                is_checked: !grandson.extend.initial_display
                                            })
                                        }
                                    })
                                }
                                if (child.extend.is_show_switch) {
                                    this.fieldSiteList.push({
                                        ...child,
                                        is_checked: !child.extend.initial_display
                                    })
                                }
                            })
                        }
                        this.formInfoList.push(field)
                        this.componentPropertyForm = field
                        this.$set(this.componentPropertyForm, 'extend', field.extend)
                        if (item.field_type === 'reimbursement') {
                            const relate_type_options = this.getGrandsonField('reimbursement_relate_type', 'reimbursement_form', this.componentPropertyForm).options
                            this.reimbursementRelateTypeList.forEach(type => {
                                if (relate_type_options.findIndex(option => option.value === type.value) > -1) {
                                    type.checked = true
                                }
                                if (type.value === 'approval' && type.checked && this.approvalTypeList.length === 0) {
                                    this.getApprovalTypeList()
                                }
                            })
                            this.getReimbursementTypeList().then(res => {
                                const reimbursement_type = this.getGrandsonField('reimbursement_type', 'reimbursement_form', this.componentPropertyForm)
                                res.forEach(item => {
                                    item.checked = true
                                    reimbursement_type.options_ids.push(item.reimbursements_type_id)
                                })
                                this.reimbursementTypeList = res
                            })
                        }
                        this.fieldKeyIndex++
                        this.canSelectTableRules()
                    }
                }
            })
        },

        canSelectTableRules(first) {
            const tables = []
            this.formInfoList.forEach(item => {
                if (item.field_type === 'control') {
                    tables.push(item.field_key.split('control_')[1])
                }
            })
            if (tables.length) {
                let res = [];
                const control = {
                    "payable": ["stock_movement"],
                    "stock_movement": ["payable"],
                };
                tables.forEach(table => {
                    res.push(control[table] || []);
                });
                const intersection = res.reduce((acc, curr) => {
                    return acc.filter(value => curr.includes(value));
                });
                this.controlsOptionsList.forEach(item => {
                    item.types.forEach(child => {
                        if (intersection.indexOf(child.field_type) < 0) {
                            this.$set(child, 'disabled', false)
                        } else {
                            this.$set(child, 'disabled', true)
                        }
                    })
                })
            } else {
                this.controlsOptionsList.forEach(item => {
                    item.types.forEach(child => {
                        if (first) {
                            if (!child.hasOwnProperty('disabled')) {
                                this.$set(child, 'disabled', true)
                            }
                        } else {
                            this.$set(child, 'disabled', true)
                        }
                    })
                })
            }
        },

        getChildField(field_key, formData) {
            return formData['_child'].find(item => item.field_key === field_key) || {}
        },

        getGrandsonField(field_key, p_field_key, formData) {
            return this.getChildField(p_field_key, formData)['_child'].find(item => item.field_key === field_key) || {}
        },

        //排序方法
        assignSortValue(arr, parentSort = 0) {
            let sort = parentSort;
            arr.forEach((obj, index) => {
                sort += 1;
                obj.sort = sort; // 设置sort字段的值
                if (obj._child && obj._child.length > 0) {
                    obj._child.forEach(child => {
                        child.p_field_key = obj.field_key
                    })
                    this.assignSortValue(obj._child, sort);
                    sort = obj._child[obj._child.length - 1].sort; // 更新sort的值为最后一个子对象的sort
                }
            });
        },

        //点击中间的表单项目
        handleClickCenterFormItem(field) {
            if (this.$refs.componentPropertyForm) {
                this.$refs.componentPropertyForm.validate((valid, errors) => {
                    if (valid) {
                        if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                            this.validateComponentPropertyFormRules().then(isValid => {
                                if (isValid) {
                                    // 验证成功后的逻辑
                                    this.validateSuccessfulFun(field)
                                }
                            })
                        } else {
                            this.validateSuccessfulFun(field)
                        }
                    } else {
                        const firstErrorField = Object.keys(errors)[0]; // 获取第一个校验失败的字段
                        this.$message.error(errors[firstErrorField][0].message)
                    }
                })
            } else {
                this.validateSuccessfulFun(field)
            }
        },

        validateSuccessfulFun(field) {
            this.componentPropertyForm = field
            this.$set(this.componentPropertyForm, 'extend', field.extend)
            this.basicSettingGroup = 'basic'
        },

        //拖拽中间的表单项目移动
        onDragCenterFormItemMove(e) {
            if (e.relatedContext.element && e.relatedContext.element.extend && e.relatedContext.element.extend.hasOwnProperty('can_draggable')) return false
            if (e.relatedContext && e.draggedContext.element && (e.draggedContext.element.field_type === 'table' || e.draggedContext.element.field_type === 'explain') && e.to.className === 'table_drag_wrapper') return false
        },

        //拖拽中间的表单项目结束
        onDragCenterFormItemEnd() {
            this.assignSortValue(this.formInfoList)
        },

        //点击分组下的表单项目
        handleClickFormModuleFieldItem(field, parent) {
            if (this.$refs.componentPropertyForm) {
                this.$refs.componentPropertyForm.validate((valid, errors) => {
                    if (valid) {
                        if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                            this.validateComponentPropertyFormRules().then(isValid => {
                                if (isValid) {
                                    // 验证成功后的逻辑
                                    this.theLogicFollowingSuccessful(field, parent)
                                }
                            })
                        } else {
                            this.theLogicFollowingSuccessful(field, parent)
                        }
                    } else {
                        const firstErrorField = Object.keys(errors)[0]; // 获取第一个校验失败的字段
                        this.$message.error(errors[firstErrorField][0].message)
                    }
                })
            } else {
                this.theLogicFollowingSuccessful(field, parent)
            }
        },

        theLogicFollowingSuccessful(field, parent) {
            this.basicSettingGroup = 'basic';
            if (field.field_type === 'order_amount_compute_mode') {
                this.componentPropertyForm = parent
                this.$set(this.componentPropertyForm, 'extend', parent.extend)
            } else {
                this.componentPropertyForm = field
                this.$set(this.componentPropertyForm, 'extend', field.extend)
                if (field.field_type === 'radio_workorder_type') {
                    this.getWorkOrderTypeList()
                } else if (field.field_type === 'workorder_role') {
                    this.handleRelateRolesSelectFocus()
                }
            }
        },

        //获取工单类型
        getWorkOrderTypeList() {
            workOrderTypeList().then(res => {
                if (res.code === 200) {
                    this.componentPropertyForm.extend.options = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        },

        handleWorkorderTypeInputBlur() {
            this.$refs.componentPropertyForm.validateField('workorder_types', error => {
                if (error) return this.$message.error(error)
                workOrderTypeEdit({
                    types: this.componentPropertyForm.extend.options
                }).then(res => {
                    if (res.code === 200) {
                        this.getWorkOrderTypeList()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            })
        },

        //点击添加分组
        handleClickAddFormModule() {
            const data = {
                field_form: this.field_form,
                field_key: 'field_' + this.fieldKeyIndex,
                field_name: "",
                field_type: "form_module",
                is_system: 0,
                is_system_key: '0',
                is_required: 0,
                is_unique: 0,
                status: 0,
                extend: {},
                rules: [],
                _child: [],
                sort: this.formInfoList.length + 1,
                field_name_edit: true,
                p_field_key: '',
                quote_field_form: '',
                quote_field_key: '',
            }
            if (this.field_form === 'users') {
                data.extend.is_form_show = true
            } else if (this.field_form === 'orders') {
                data.extend.hidden_field = false
                data.extend.can_set_discontinue = false
            }
            if (this.$refs.componentPropertyForm) {
                this.$refs.componentPropertyForm.validate((valid, errors) => {
                    if (valid) {
                        if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                            this.validateComponentPropertyFormRules().then(isValid => {
                                if (isValid) {
                                    // 验证成功后的逻辑
                                    this.basicSettingGroup = 'basic'
                                    this.formInfoList.push(data)
                                    this.componentPropertyForm = this.formInfoList[this.formInfoList.length - 1]
                                    this.$set(this.componentPropertyForm, 'extend', this.formInfoList[this.formInfoList.length - 1].extend)
                                    this.fieldKeyIndex++
                                }
                            })
                        } else {
                            this.formInfoList.push(data)
                            this.componentPropertyForm = this.formInfoList[this.formInfoList.length - 1]
                            this.$set(this.componentPropertyForm, 'extend', this.formInfoList[this.formInfoList.length - 1].extend)
                            this.fieldKeyIndex++
                        }
                    } else {
                        const firstErrorField = Object.keys(errors)[0]; // 获取第一个校验失败的字段
                        this.$message.error(errors[firstErrorField][0].message)
                    }
                })
            } else {
                this.formInfoList.push(data)
                this.componentPropertyForm = this.formInfoList[this.formInfoList.length - 1]
                this.$set(this.componentPropertyForm, 'extend', this.formInfoList[this.formInfoList.length - 1].extend)
                this.fieldKeyIndex++
            }
        },

        //点击设置字段名称
        handleClickEditFieldName(field) {
            if (field.hasOwnProperty('field_name_edit')) {
                field.field_name_edit = true
            } else {
                this.$set(field, 'field_name_edit', true)
            }
            this.$nextTick(() => {
                this.$refs[`field_name_input_${field.field_key}`][0].focus()
            })
        },

        //字段名称输入框失焦事件
        handleFieldNameInputBlur(field) {
            if (field.field_name) {
                field.field_name_edit = false
            }
        },

        //表单名称输入框回车事件
        handleFieldNameEnter(field) {
            if (field.field_name) {
                this.$refs[`field_name_input_${field.field_key}`][0].blur()
            }
        },

        //右侧设置表单的名称输入框失焦事件
        handlePropertyFormFieldNameInputBlur() {
            if (this.componentPropertyForm.field_type === 'form_module') {
                this.formInfoList.find(item => item.field_key === this.componentPropertyForm.field_key).field_name_edit = false
            }
        },

        //点击删除分组
        handleClickDeleteFormModule(field_key) {
            this.formInfoList.splice(this.formInfoList.findIndex(item => item.field_key === field_key), 1)
            this.$message.success("删除成功")
            if (this.componentPropertyForm.field_key === field_key) {
                this.componentPropertyForm = this.formInfoList.length === 0 ? {} : this.formInfoList[0]
            }
        },

        //点击删除分组下的字段
        handleClickDeleteFormModuleField(field, list) {
            if (field.is_system === 1) return this.$message.error('该字段为系统字段，不允许移除')
            if (field.field_type === 'order_amount_compute_mode') return false
            // if (field.field_type === 'workorder_role' && field.field_id) {
            //     workOrderFormRoleDelCheck({field_id: field.field_id}).then(res => {
            //         if (res.code === 200) {
            //             if (res.data.is_exist) {
            //                 this.$msgbox({
            //                     title: '是否删除所选字段？',
            //                     message: `该字段已作为自动分配实施人员的规则`,
            //                     confirmButtonText: '确定',
            //                     cancelButtonText: '取消',
            //                     iconClass: 'iconfont icon-shuoming',
            //                     showCancelButton: true,
            //                     closeOnClickModal: false,
            //                     closeOnPressEscape: false,
            //                     customClass: 'icon_title_message_box icon_title_message_box_warning'
            //                 }).then(() => {
            //                     this.delFieldMethods(field, list)
            //                 }).catch(() => {

            //                 });
            //             } else {
            //                 this.delFieldMethods(field, list)
            //             }
            //         }
            //     })
            //     return false;
            // }
            const compute_mode_fields = ['money', 'number', 'compute_mode', 'date_range', 'money_compute_mode']
            const num_field = this.delNumberFieldFun(field, true)
            if (compute_mode_fields.includes(field.field_type) && num_field) {
                this.$msgbox({
                    title: '移除',
                    message: `该字段已在${num_field.field_name}的计算公式中使用，请先编辑计算公式后再删除`,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-shuoming',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_warning'
                }).then(() => {

                }).catch(() => {

                });
                return false
            }
            if (field.field_type === 'table') {
                const child_computed = field._child.find(child => compute_mode_fields.includes(child.field_type) && this.delNumberFieldFun(child, false))
                if (child_computed) {
                    this.$msgbox({
                        title: '移除',
                        message: `当前明细/表格下的${child_computed.field_name}字段已在计算公式中使用，请先编辑计算公式后再删除`,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        iconClass: 'iconfont icon-shuoming',
                        showCancelButton: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        customClass: 'icon_title_message_box icon_title_message_box_warning'
                    }).then(() => {

                    }).catch(() => {

                    });
                    return false
                }
            }
            const rules_list = this.extractRules(list)
            let rules = []
            if (field.field_type === 'control') {
                rules = rules_list.filter(rule => rule.p_field_key === field.field_key)
            } else {
                rules = rules_list.filter(rule => rule.field_key === field.field_key)
            }
            if (rules.length > 0) {
                const rules_str = rules.map(rule => rule.now_field_name).join()
                const msg = rules.length === 1 ? rules_str + '控件' : rules_str + '等控件'
                const h = this.$createElement;
                this.$msgbox({
                    title: '移除',
                    message: h('p', null, [
                        h('span', null, '该控件/选项已作为'),
                        h('span', {style: 'color: #1990ff'}, msg),
                        h('span', null, '的显隐条件，是否确定移除？'),
                    ]),
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-shuoming',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_warning'
                }).then(() => {
                    this.delFieldMethods(field, list)
                    rules.forEach(rule => {
                        const item = list.find(field => field.field_key === rule.now_field_key)
                        if (item.field_type === 'control') {
                            item.rules = item.rules.map(subArray => subArray.filter(every => !(every.type === 'field' && every.p_field_key === field.field_key)));
                        } else {
                            item.rules = item.rules.map(subArray => subArray.filter(every => !(every.type === 'field' && every.field_key === field.field_key)));
                        }
                        item.rules = item.rules.filter(subArray => subArray.length > 0);
                        if (item.rules.length === 0) {
                            item.extend.initial_display = false
                        }
                    })
                }).catch(() => {

                });
            } else {
                this.delFieldMethods(field, list)
            }
        },

        //点击删除控件组下的字段
        handleClickDeleteControlGroupField(field) {
            this.$set(field.extend, 'initial_display', true)
            this.fieldSiteList.find(item => item.field_key === field.field_key).is_checked = false
        },

        //删除字段的方法
        delFieldMethods(field, list) {
            console.log(this.field_form);
            if ((this.field_form === 'projects' || this.field_form === 'project_stage_tasks') && field.hasOwnProperty('field_id')) {
                checkFieldUsage({
                    field_key: field.field_key,
                    field_form: this.field_form,
                }).then(res => {
                    if (res.code === 200) {
                        if (res.data.is_usage) {
                            this.$message.error('该字段已在商机阶段规则中被使用，无法移除')
                        } else {
                            list.splice(list.findIndex(item => item.field_key === field.field_key), 1)
                            this.$emit('del-field-condition', field)
                            this.$message.success("删除成功")
                            if (this.componentPropertyForm.field_key === field.field_key) {
                                this.componentPropertyForm = list.length === 0 ? {} : list[0]
                            }
                        }
                    } else {

                    }
                })
            } else if (this.field_form === 'workorders' && field.hasOwnProperty('field_id')) {
                checkFieldUsage({
                    field_key: field.field_key,
                    field_form: this.field_form,
                }).then(res => {
                    if (res.code === 200) {
                        if (res.data.is_usage) {
                            this.$message.error('该字段已作为自动分配实施人员的规则，无法移除')
                        } else {
                            list.splice(list.findIndex(item => item.field_key === field.field_key), 1)
                            this.$emit('del-field-condition', field)
                            this.$message.success("删除成功")
                            if (this.componentPropertyForm.field_key === field.field_key) {
                                this.componentPropertyForm = list.length === 0 ? {} : list[0]
                            }
                        }
                    } else {

                    }
                })
            } else {
                list.splice(list.findIndex(item => item.field_key === field.field_key), 1)
                this.$emit('del-field-condition', field)
                this.$message.success("删除成功")
                if (this.componentPropertyForm.field_key === field.field_key) {
                    this.componentPropertyForm = list.length === 0 ? {} : list[0]
                }
                this.canSelectTableRules()
            }
        },

        //删除数字类型的方法
        delNumberFieldFun(field, table_push) {
            const all_field = []
            if (this.is_form_module) {
                this.formInfoList.forEach(item => {
                    if (item._child && item._child.length > 0) {
                        item._child.forEach(child => {
                            if (child.field_type === 'compute_mode') {
                                if (child.extend.formula && child.field_key !== this.componentPropertyForm.field_key) {
                                    all_field.push(child)
                                }
                            } else if (child.field_type === 'table' && child._child && child._child.length > 0 && table_push) {
                                child._child.forEach(grandson => {
                                    if (grandson.field_type === 'compute_mode') {
                                        if (grandson.extend.formula && grandson.field_key !== this.componentPropertyForm.field_key) {
                                            all_field.push(grandson)
                                        }
                                    }
                                })
                            }
                        })
                    }
                })
            } else {
                this.formInfoList.forEach(item => {
                    if (item.field_type === 'compute_mode') {
                        all_field.push(item)
                    } else if (item.field_type === 'table' && table_push) {
                        item._child.forEach(child => {
                            if (child.field_type === 'compute_mode') {
                                all_field.push(child)
                            }
                        })
                    } else if (item.field_type === 'control') {
                        item._child.forEach(child => {
                            if (child.field_type === 'money_compute_mode') {
                                all_field.push(child)
                            }
                        })
                    }
                })
            }
            return all_field.find(item => item.extend.field_formula.includes(field.field_key))
        },

        extractRules(data, p_field_name) {
            let result = [];

            data.forEach(obj => {
                let rules = obj.rules || [];
                result.push(
                        ...rules.flat().map(rule => ({
                            ...rule,
                            now_field_name: p_field_name ? p_field_name + '.' + obj.field_name : obj.field_name,
                            now_field_key: obj.field_key,
                        }))
                );

                let child = obj._child || [];
                result.push(...this.extractRules(child));
            });

            return result;
        },

        //点击切换字段是否必填
        handleFieldIsRequiredChange(field) {
            const compute_mode_fields = ['money', 'number', 'compute_mode', 'date_range', 'money_compute_mode']
            const num_field = this.delNumberFieldFun(field, true)
            if (field.is_required === 0 && compute_mode_fields.includes(field.field_type) && num_field) {
                field.is_required = 1
                this.$msgbox({
                    title: '必填',
                    message: `该字段已在${num_field.field_name}的计算公式中使用，请先编辑计算公式后再切换`,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-shuoming',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_warning'
                }).then(() => {

                }).catch(() => {

                });
            }
        },

        //计算公式输入框聚焦事件
        handleFormulaInputFocus() {
            this.components_list = []
            if (this.is_form_module) {
                this.formInfoList.forEach(item => {
                    if (item._child && item._child.length > 0) {
                        item._child.forEach(child => {
                            if (child.field_type === 'money' || child.field_type === 'number') {
                                if (child.is_required === 1) {
                                    child.new_field_name = child.field_name
                                    child.p_field_type = item.field_type
                                    this.components_list.push(child)
                                }
                            } else if (child.field_type === 'compute_mode') {
                                if (child.extend.formula && child.field_key !== this.componentPropertyForm.field_key) {
                                    child.new_field_name = child.field_name
                                    child.p_field_type = item.field_type
                                    this.components_list.push(child)
                                }
                            } else if (child.field_type === 'date_range') {
                                if (child.is_required === 1 && child.extend.auto_computed) {
                                    child.new_field_name = `「${child.field_name}」时长`
                                    child.p_field_type = item.field_type
                                    this.components_list.push(child)
                                }
                            } else if (child.field_type === 'table') {
                                if (child._child && child._child.length > 0) {
                                    child._child.forEach(grandson => {
                                        if (grandson.field_type === 'money' || grandson.field_type === 'number') {
                                            if (grandson.is_required === 1) {
                                                grandson.p_field_type = child.field_type
                                                grandson.new_field_name = `「${child.field_name}」${grandson.field_name}`
                                                this.components_list.push(grandson)
                                            }
                                        } else if (grandson.field_type === 'compute_mode') {
                                            if (grandson.extend.formula && grandson.field_key !== this.componentPropertyForm.field_key) {
                                                grandson.p_field_type = child.field_type
                                                grandson.new_field_name = `「${child.field_name}」${grandson.field_name}`
                                                this.components_list.push(grandson)
                                            }
                                        } else if (grandson.field_type === 'date_range') {
                                            if (grandson.is_required === 1 && grandson.extend.auto_computed) {
                                                grandson.new_field_name = `「${grandson.field_name}」时长`
                                                grandson.p_field_type = child.field_type
                                                this.components_list.push(child)
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    }
                })
            } else {
                if (this.componentPropertyForm.p_field_key) {
                    const p_field = this.formInfoList.find(item => item.field_key === this.componentPropertyForm.p_field_key)
                    const {_child, field_name} = p_field
                    _child.forEach(child => {
                        if (child.field_type === 'money' || child.field_type === 'number') {
                            if (child.is_required) {
                                child.new_field_name = field_name + '.' + child.field_name
                                this.components_list.push(child)
                            }
                        } else if (child.field_type === 'compute_mode') {
                            if (child.formula && child.field_key !== this.componentPropertyForm.field_key) {
                                child.new_field_name = field_name + '.' + child.field_name
                                this.components_list.push(child)
                            }
                        } else if (child.field_type === 'date_range') {
                            if (child.is_required === 1 && child.extend.auto_computed) {
                                child.new_field_name = `「${field_name}.${child.field_name}」时长`
                                this.components_list.push(child)
                            }
                        }
                    })
                } else {
                    this.formInfoList.forEach(item => {
                        if (item.field_type === 'money' || item.field_type === 'number') {
                            if (item.is_required === 1) {
                                item.new_field_name = item.field_name
                                this.components_list.push(item)
                            }
                        } else if (item.field_type === 'compute_mode') {
                            if (item.extend.formula && item.field_key !== this.componentPropertyForm.field_key) {
                                item.new_field_name = item.field_name
                                this.components_list.push(item)
                            }
                        } else if (item.field_type === 'date_range') {
                            if (item.is_required === 1 && item.extend.auto_computed) {
                                item.new_field_name = `「${item.field_name}」时长`
                                this.components_list.push(item)
                            }
                        } else if (item.field_type === 'table') {
                            item._child.forEach(child => {
                                if (child.field_type === 'money' || child.field_type === 'number') {
                                    if (child.is_required === 1) {
                                        child.p_field_type = item.field_type
                                        child.new_field_name = item.field_name + '.' + child.field_name
                                        this.components_list.push(child)
                                    }
                                } else if (child.field_type === 'compute_mode') {
                                    if (child.extend.formula && child.field_key !== this.componentPropertyForm.field_key) {
                                        child.p_field_type = item.field_type
                                        child.new_field_name = item.field_name + '.' + child.field_name
                                        this.components_list.push(child)
                                    }
                                } else if (child.field_type === 'date_range') {
                                    if (child.is_required === 1 && child.extend.auto_computed) {
                                        child.p_field_type = item.field_type
                                        child.new_field_name = `「${item.field_name}.${child.field_name}」时长`
                                        this.components_list.push(child)
                                    }
                                }
                            })
                        } else if (item.field_type === 'control') {
                            if (item.field_key !== this.componentPropertyForm.field_key) {
                                item._child.forEach(child => {
                                    if (child.field_type === 'money_compute_mode') {
                                        child.p_field_type = item.field_type
                                        child.new_field_name = item.field_name + '.' + child.field_name
                                        this.components_list.push(child)
                                    }
                                })
                            }
                        }
                    })
                }
            }
            this.formulaEditDialogShow = true
            if (this.componentPropertyForm.field_key === 'control_payable') {
                this.nowFieldFormulaList = this.getChildField('payable_amount', this.componentPropertyForm).extend.formula_list
            } else {
                this.nowFieldFormulaList = this.componentPropertyForm.extend.formula_list
            }
        },

        //计算公式组件确定事件
        formulaEditFormConfirm(data) {
            if (this.componentPropertyForm.field_key === 'control_payable') {
                this.$set(this.getChildField('payable_amount', this.componentPropertyForm).extend, 'formula_list', data.formula_items)
                this.$set(this.getChildField('payable_amount', this.componentPropertyForm).extend, 'formula', data.formula)
                this.$set(this.getChildField('payable_amount', this.componentPropertyForm).extend, 'field_formula', data.field_formula)
            } else {
                this.componentPropertyForm.extend.formula_list = data.formula_items
                this.componentPropertyForm.extend.formula = data.formula
                this.componentPropertyForm.extend.field_formula = data.field_formula
            }
            this.$refs.componentPropertyForm.validateField('formula')
            this.formulaEditDialogShow = false
        },

        //点击添加订单金额信息
        handleClickAddAmountInformation() {
            this.amountInformationDialog = true
            if (!this.componentPropertyForm.hasOwnProperty('_child')) {
                this.componentPropertyForm._child = []
            }
        },

        //订单金额信息编辑事件
        handleClickEditAmountItem(item) {
            this.amount_field_key = item.field_key
            this.amountInformationDialog = true
            for (const rowKey in this.amountInformationForm) {
                if (item.hasOwnProperty(rowKey)) {
                    this.amountInformationForm[rowKey] = item[rowKey]
                } else {
                    this.amountInformationForm[rowKey] = item.extend[rowKey]
                }
            }
        },

        //订单金额信息状态切换事件
        handleClickCheckIsUpper(item) {
            if (item.status == 1) {
                item.status = 0
                this.$message.success('已启用')
            } else {
                const other_field = this.componentPropertyForm._child.find(field => field.extend.field_formula.includes(item.field_key) && field.status == 0)
                if (other_field) {
                    this.$msgbox({
                        title: '该金额已作为基础数值被使用',
                        message: '请先修改其他金额的计算公式后再停用',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        iconClass: 'iconfont icon-shuoming',
                        showCancelButton: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        customClass: 'icon_title_message_box icon_title_message_box_warning'
                    }).then(() => {
                    }).catch(() => {
                        return false
                    })
                } else {
                    this.$msgbox({
                        title: '是否停用所选金额？',
                        message: '停用后新建的订单或编辑停用前的订单将不展示该金额',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        iconClass: 'iconfont icon-yiwen',
                        showCancelButton: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        customClass: 'icon_title_message_box icon_title_message_box_danger',
                        confirmButtonClass: "el-button--danger",
                    }).then(() => {
                        item.status = 1
                        this.$message.success('已停用')
                    }).catch(() => {
                        return false
                    })
                }
            }
        },

        //订单金额删除事件
        handleClickDelAmountItem(field, index) {
            const other_field = this.componentPropertyForm._child.find(item => item.extend.field_formula.includes(field.field_key))
            if (other_field && other_field.status == 0) {
                this.$msgbox({
                    title: '该金额已作为基础数值被使用',
                    message: '请先修改其他金额的计算公式后再删除',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-shuoming',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_warning'
                }).then(() => {

                }).catch(() => {
                    return false
                })
            } else {
                this.$msgbox({
                    title: '是否删除所选金额？',
                    message: '删除后新建的订单或编辑删除前的订单将不展示该金额',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-yiwen',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_danger',
                    confirmButtonClass: "el-button--danger",
                }).then(() => {
                    this.componentPropertyForm._child.splice(index, 1)
                    this.$message.success('删除成功')
                }).catch(() => {
                    return false
                })
            }
        },

        //订单金额信息排序事件
        onDragAmountInfoItemEnd() {
            this.componentPropertyForm._child.forEach((item, index) => {
                item.sort = this.componentPropertyForm.sort + index + 1
            })
        },

        //金额计算方式切换事件
        handleFillingMethodChange(val) {
            if (val === '2') {
                this.amountInformationForm.formula_list = []
                this.amountInformationForm.formula = ''
                this.amountInformationForm.field_formula = ''
            }
        },

        //可见人员范围输入框聚焦事件
        handleVisiblePersonInputFocus() {
            if (this.departmentUserList.length === 0) {
                this.depUserLoading = true
                this.getDepartmentAndUserList()
            }
            this.selectedDepUserList = JSON.parse(JSON.stringify(this.amountInformationForm.visible_person_range))
            this.visiblePersonDialogVisible = true
            this.order_creator = this.selectedDepUserList.findIndex(item => item.relate_type_id === 'order_creator') > -1
            this.order_approver = this.selectedDepUserList.findIndex(item => item.relate_type_id === 'order_approver') > -1
            // this.$nextTick(() => {
            //     if (this.selectedDepUserList.length > 0) {
            //         this.$refs.departUserTree.setCheckedKeys(this.selectedDepUserList.map(user => user.relate_type_id), true)
            //     }
            // })
        },

        //订单负责人
        handleClickOrderCreator(val) {
            if (val) {
                this.selectedDepUserList.push({
                    uid: 'order_creator',
                    name: '订单负责人',
                    relate_type: 'order_creator',
                    relate_type_id: 'order_creator',
                })
            } else {
                this.selectedDepUserList.splice(this.selectedDepUserList.findIndex(item => item.relate_type_id === 'order_creator'), 1)
            }
        },

        //订单审批人
        handleClickOrderApprover(val) {
            if (val) {
                this.selectedDepUserList.push({
                    uid: 'order_approver',
                    name: '订单审批人',
                    relate_type: 'order_approver',
                    relate_type_id: 'order_approver',
                })
            } else {
                this.selectedDepUserList.splice(this.selectedDepUserList.findIndex(item => item.relate_type_id === 'order_approver'), 1)
            }
        },

        //移除已选择的部门人员
        handleRemoveVisiblePersonTag(tag) {
            this.amountInformationForm.visible_person_range.splice(0, 1)
        },

        //删除已选择的部门人员
        handleClickDelSelectedUser(item, index) {
            this.selectedDepUserList.splice(index, 1)
            if (item.relate_type === 'order_creator') {
                this.order_creator = false
            } else if (item.relate_type === 'order_approver') {
                this.order_approver = false
            } else {
                this.$refs.departUserTree.setChecked(item.relate_type_id, false)
            }
        },

        //清除已选择的人员
        handleClickClearSelectedUser() {
            this.selectedDepUserList = []
            this.$refs.departUserTree.setCheckedKeys([])
            this.order_creator = false
            this.order_approver = false
        },

        //部门人员树选中事件
        handleCheckUserNodeItem(data, {checkedKeys}) {
            const dataIndex = checkedKeys.findIndex(check => check === data.relate_type_id)
            if (dataIndex > -1) {
                if (data.relate_type === 'App\\Models\\User') {
                    this.selectedDepUserList.push({
                        uid: data.relate_id,
                        name: data.relate_name,
                        relate_type: data.relate_type,
                        relate_type_id: data.relate_type_id,
                    })
                } else {
                    const arr = this.findItemsWithType1(data)
                    arr.forEach(item => {
                        if (item.relate_type === 'App\\Models\\User' && this.selectedDepUserList.findIndex(user => user.relate_type_id === item.relate_type_id) < 0) {
                            this.selectedDepUserList.push({
                                uid: item.relate_id,
                                name: item.relate_name,
                                relate_type: item.relate_type,
                                relate_type_id: item.relate_type_id,
                            })
                        }
                        this.$refs.departUserTree.setChecked(item.relate_type_id, true)
                    })
                }
            } else {
                if (data.relate_type === 'App\\Models\\User') {
                    this.selectedDepUserList.splice(this.selectedDepUserList.findIndex(item => item.relate_type_id === data.relate_type_id), 1)
                } else {
                    const arr = this.findItemsWithType1(data)
                    arr.forEach(item => {
                        if (item.relate_type === 'App\\Models\\User' && this.selectedDepUserList.findIndex(user => user.relate_type_id === item.relate_type_id) > -1) {
                            this.selectedDepUserList.splice(this.selectedDepUserList.findIndex(user => user.relate_type_id === item.relate_type_id), 1)
                        }
                        this.$refs.departUserTree.setChecked(item.relate_type_id, false)
                    })
                }
            }
        },

        findItemsWithType1(obj) {
            let result = [];

            // 递归函数
            function traverse(obj) {
                result.push(obj);

                if (Array.isArray(obj.children)) {
                    obj.children.forEach(child => {
                        traverse(child);
                    });
                }
            }

            traverse(obj);

            return result;
        },

        //获取部门与用户列表
        getDepartmentAndUserList() {
            GetDepartmentUserList({
                name: this.depUserKeyWord
            }).then(res => {
                if (res.code === 200) {
                    this.departmentUserList = res.data || [];
                    this.deepAddRelateType(this.departmentUserList);
                } else {

                }
                this.depUserLoading = false
            })
        },

        deepAddRelateType(arr) {
            arr.forEach((item) => {
                this.$set(item, "relate_type_id", item.relate_id + "_" + item.relate_type);
                if (item.children && item.children.length > 0) {
                    this.deepAddRelateType(item.children);
                }
            });
        },

        //选择可见人员范围取消事件
        handleClickVisiblePersonCancel() {
            this.select_type = '1'
            this.handleClickClearSelectedUser()
            this.visiblePersonDialogVisible = false
        },

        //选择可见人员范围确定事件
        handleClickVisiblePersonConfirm() {
            this.amountInformationForm.visible_person_range = JSON.parse(JSON.stringify(this.selectedDepUserList))
            this.handleClickVisiblePersonCancel()
        },

        //金额计计算公式输入框聚焦事件
        handleAmountFormulaInputFocus() {
            this.formulaEditVisible = true
            this.basicValueList = []
            this.componentPropertyForm._child.forEach(item => {
                if (item.status == 0 && item.extend.as_calculated_val) {
                    item.new_field_name = item.field_name
                    this.basicValueList.push(item)
                }
            })
            this.formulaItems = JSON.parse(JSON.stringify(this.amountInformationForm.formula_list))
            this.$nextTick(() => {
                if (this.formulaItems.length > 0) {
                    this.formulaItems.forEach(item => {
                        this.creatFormulaTag(item)
                    })
                }
            })
        },

        //公式输入框输入事件
        handleTextareaInput(event) {
            if (event.inputType === 'deleteContentBackward') {
                this.handleClickDel()
                return false
            }
            const regex = /[\u4E00-\u9FFFa-zA-Z~!@#$%^&*()_+\-=[\]{}|\\;:'",.<>/?]/;
            if (regex.test(event.data)) {
                if (event.data) {
                    this.$refs.textarea_div.innerText = ''
                    this.formulaItems.forEach(item => {
                        this.creatFormulaTag(item)
                    })
                }
            } else {
                if (this.formulaItems.length > 0 && this.formulaItems[this.formulaItems.length - 1].type === 'number') {
                    const last = this.formulaItems[this.formulaItems.length - 1]
                    last.content += event.data
                } else {
                    const number = {
                        type: 'number',
                        content: event.data,
                        field_key: '',
                    }
                    this.formulaItems.push(number);
                }
            }
        },

        //公式输入框键盘事件
        handleTextareaKeyDown(e) {
            if (this.keyCodeList.indexOf(e.keyCode) < 0) {
                e.preventDefault()
            }
        },

        //点击组件
        handleClickComponentsItem(item) {
            const component = {
                type: 'component',
                content: item.new_field_name,
                field_key: item.field_key,
                field_type: item.field_type,
                p_field_key: item.p_field_key,
            }
            this.formulaItems.push(component);
            this.creatFormulaTag(component);
        },

        //点击系统默认字段
        handleClickSystemComponentsItem(type) {
            if (type === 'total_price') {
                const total_price = this.formInfoList.find(field => field.field_key === 'goods_information')._child.find(child => child.field_key === 'total_price')
                if (total_price) {
                    total_price.new_field_name = total_price.field_name
                    this.handleClickComponentsItem(total_price)
                }
            } else {
                const types = this.formulaItems.filter(item => item.type === type)
                let component = {
                    type: type,
                    content: '',
                    field_key: type + '_' + (types.length + 1),
                    field_type: 'money',
                    p_field_key: '',
                    commodity_value_config: [],
                }
                if (type === 'product_cost') {
                    component.content = '产品成本' + (types.length + 1)
                } else if (type === 'product_total_price') {
                    component.content = '产品总价' + (types.length + 1)
                } else if (type === 'purchase_price') {
                    component.content = '代采成本'
                    component.field_key = 'purchase_price'
                }
                this.formulaItems.push(component);
                this.creatFormulaTag(component);
            }
        },

        //点击符号
        handleClickSymbolItem(item) {
            const symbol = {
                type: 'symbol',
                content: item.value,
                field_key: '',
            }
            this.formulaItems.push(symbol);
            this.creatFormulaTag(symbol)
        },

        //创建公式标签
        creatFormulaTag(item) {
            const tag = document.createElement('span');
            tag.style.display = 'inline-block'; // 设置样式为行内块元素
            item.type === 'number' ? tag.className = '' : tag.className = 'formula_item'; // 添加 CSS 类名
            tag.textContent = item.content; // 设置元素文本内容
            // tag.dataset.item = JSON.stringify(item); // 设置自定义数据属性，值为 item 对象的 JSON 字符串
            this.$refs.textarea_div.appendChild(tag); // 将新创建的元素添加到 textarea_div 中
            tag.addEventListener('click', event => {
                event.preventDefault(); // 取消默认行为，阻止光标聚焦在 <span> 标签上
                this.changeRange()
            });
            this.changeRange()
        },

        //重新设置鼠标焦点位置
        changeRange() {
            const nextTextNode = new Text('\u200b'); // 创建一个包含 0 宽字符（零宽度空格）的文本节点
            this.$refs.textarea_div.appendChild(nextTextNode); // 将 0 宽字符文本节点添加到 textarea_div 中
            this.$refs.textarea_div.focus(); // 输入框获得焦点
            const range = new Range(); // 创建一个 range 对象
            const selection = window.getSelection(); // 获取当前窗口的选区对象
            range.setStart(nextTextNode, 1); // 设置 range 的起始位置为 0 宽字符之后的第一个字符
            range.setEnd(nextTextNode, 1); // 设置 range 的结束位置为 0 宽字符之后的第一个字符
            selection.removeAllRanges(); // 移除所有的选区范围
            selection.addRange(range); // 将刚刚创建的 range 对象添加到选区中
        },

        //删除公式
        handleClickDel() {
            if (this.formulaItems.length > 0) {
                this.formulaItems.pop()
                this.$refs.textarea_div.innerText = ''
                this.formulaItems.forEach(item => {
                    this.creatFormulaTag(item)
                })
            }
        },

        //清空公式
        handleClickClearFormula() {
            if (this.formulaItems.length > 0) {
                this.$confirm('确定清空公式？', '清空提示', {
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    type: 'warning'
                }).then(() => {
                    this.formulaItems = []
                    this.$refs.textarea_div.innerText = ''
                }).catch(() => {
                    return false
                })
            }
        },

        //计算公式配置取消事件
        handleClickFormulaEditCancel() {
            this.formulaEditVisible = false
            this.formulaItems = []
            this.$refs.textarea_div.innerText = ''
        },

        //计算公式配置确定事件
        handleClickFormulaEditConfirm() {
            this.amountInformationForm.formula_list = this.formulaItems
            this.amountInformationForm.formula = ''
            this.amountInformationForm.field_formula = ''
            this.formulaItems.forEach(item => {
                this.amountInformationForm.formula += item.content
                this.amountInformationForm.field_formula += item.field_key ? item.field_key : item.content
            })
            this.$message.success('公式设置成功')
            this.$refs.amountInformationForm.validateField('formula')
            this.handleClickFormulaEditCancel()
        },

        //订单金额弹窗取消事件
        handleClickAmountInformationCancel() {
            this.amountInformationForm = this.$options.data().amountInformationForm
            this.$refs.amountInformationForm.resetFields()
            this.amountInformationDialog = false
            this.amount_field_key = ''
            this.btnDisabled = false
        },

        //订单金额弹窗确定事件
        handleClickAmountInformationConfirm() {
            this.$refs.amountInformationForm.validate(valid => {
                if (valid) {
                    this.btnDisabled = true
                    if (this.amount_field_key) {
                        const field = this.componentPropertyForm._child.find(item => item.field_key === this.amount_field_key)
                        field.field_name = this.amountInformationForm.field_name
                        field.extend = {
                            as_calculated_val: this.amountInformationForm.as_calculated_val,
                            filling_method: this.amountInformationForm.filling_method,
                            num_display_style: this.amountInformationForm.num_display_style,
                            visible_person_range: this.amountInformationForm.visible_person_range,
                            formula: this.amountInformationForm.formula,
                            field_formula: this.amountInformationForm.field_formula,
                            formula_list: this.amountInformationForm.formula_list,
                            some: this.amountInformationForm.some,
                            applicable_products: this.amountInformationForm.applicable_products,
                            col_span: 12,
                            initial_display_delete: false
                        }
                    } else {
                        this.componentPropertyForm._child.push({
                            field_name: this.amountInformationForm.field_name,
                            field_key: 'field_' + this.fieldKeyIndex,
                            field_type: 'order_amount_compute_mode',
                            sort: this.componentPropertyForm._child.length,
                            is_system: 0,
                            is_system_key: 0,
                            is_unique: 0,
                            is_required: 0,
                            p_field_key: this.componentPropertyForm.field_key,
                            rules: [],
                            extend: {
                                as_calculated_val: this.amountInformationForm.as_calculated_val,
                                filling_method: this.amountInformationForm.filling_method,
                                num_display_style: this.amountInformationForm.num_display_style,
                                visible_person_range: this.amountInformationForm.visible_person_range,
                                formula: this.amountInformationForm.formula,
                                field_formula: this.amountInformationForm.field_formula,
                                formula_list: this.amountInformationForm.formula_list,
                                some: this.amountInformationForm.some,
                                applicable_products: this.amountInformationForm.applicable_products,
                                col_span: 12,
                                initial_display_delete: false
                            },
                            quote_field_form: '',
                            quote_field_key: '',
                            status: 0,
                        })
                        this.fieldKeyIndex++
                    }
                    this.handleClickAmountInformationCancel()
                } else {
                    return false
                }
            })
        },

        //获取对应的商品数值配置
        getCommodityValueConfig(type) {
            return this.formulaItems.filter(item => item.type === type)
        },

        //名称输入框失去焦点
        handleContentNameBlur(item) {
            this.$set(this.formulaItems.find(formula => formula.field_key === item.field_key), 'content', item.content)
            this.$refs.textarea_div.innerText = ''
            this.formulaItems.forEach(item => {
                this.creatFormulaTag(item)
            })
            item.is_edit = false
        },

        handleContentNameEnter(item) {
            this.$set(this.formulaItems.find(formula => formula.field_key === item.field_key), 'content', item.content)
            this.$refs.textarea_div.innerText = ''
            item.is_edit = false
        },

        //点击编辑名称
        handleClickEditContentName(item) {
            if (item.hasOwnProperty('is_edit')) {
                item.is_edit = true
            } else {
                this.$set(item, 'is_edit', true)
            }
        },

        //点击配置商品
        handleClickGoodsConfig(item) {
            this.formulaData = item
            this.selectProductsVisible = true
            let selectedGoodsList = []
            if (item.commodity_value_config && item.commodity_value_config.length) {
                selectedGoodsList = item.commodity_value_config.map(config => {
                    return {
                        category_id: config.category_id,
                        id: config.id,
                        name: config.name,
                        type: config.type,
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs.select_product_dialog.selectedGoodsList = selectedGoodsList
            })
        },

        //配置商品确认
        handleClickChooseGoodsConfirm(selectedGoodsList) {
            this.formulaData.commodity_value_config = selectedGoodsList.map(item => {
                return {
                    category_id: item.category_id,
                    id: item.id,
                    name: item.name,
                    type: item.type,
                }
            })
        },

        //点击快捷添加选项
        handleQuickAddOption() {
            this.quickAddOptionDialog = true
        },

        //快捷添加选项取消事件
        handleClickQuickAddOptionCancel() {
            this.quickAddOptionDialog = false
            this.quickAddOptionText = ''
        },

        //快捷添加选项确定事件
        handleClickQuickAddOptionConfirm() {
            const array = this.quickAddOptionText.split("\n");
            if (array.length > 0) {
                if (!array.every(item => item.trim().length <= 30)) return this.$message.error('选项名不能超过30个字符，请重新输入')
                array.forEach(item => {
                    if (item.trim() !== '') {
                        if (this.componentPropertyForm.field_type === 'radio') {
                            this.componentPropertyForm.extend.options.push({
                                label: item.trim(),
                                value: this.componentPropertyForm.extend.max_option_value,
                                default: false,
                            })
                        } else {
                            this.componentPropertyForm.extend.options.push({
                                label: item.trim(),
                                value: this.componentPropertyForm.extend.max_option_value,
                            })
                        }
                        this.componentPropertyForm.extend.max_option_value++
                    }
                })
            } else {
                this.$message.error('请输入要添加的选项')
            }
            this.$refs.componentPropertyForm.validateField('extend.options')
            this.handleClickQuickAddOptionCancel()
        },

        //点击添加选项
        handleClickAddExtendOptions() {
            if (this.componentPropertyForm.field_type === 'radio') {
                this.componentPropertyForm.extend.options.push({
                    label: "",
                    value: this.componentPropertyForm.extend.max_option_value,
                    default: false,
                })
                this.$refs.componentPropertyForm.validateField('extend.options')
            } else if (this.componentPropertyForm.field_type === 'checkbox') {
                this.componentPropertyForm.extend.options.push({
                    label: "",
                    value: this.componentPropertyForm.extend.max_option_value,
                })
                this.$refs.componentPropertyForm.validateField('extend.options')
            } else if (this.componentPropertyForm.field_type === 'cascader') {
                this.componentPropertyForm.extend.options.push({
                    label: "",
                    value: this.componentPropertyForm.extend.max_option_value,
                })
                this.$refs.componentPropertyForm.validateField('extend.cascader_options')
            } else if (this.componentPropertyForm.field_type === 'radio_workorder_type') {
                this.componentPropertyForm.extend.options.push({
                    name: "",
                    id: "",
                })
                this.$refs.componentPropertyForm.validateField('workorder_types')
            }
            this.componentPropertyForm.extend.max_option_value++
        },

        //点击删除选项
        handleClickDelExtendOptions(index) {
            if (this.componentPropertyForm.field_type === 'radio_workorder_type') {
                this.$msgbox({
                    title: '是否删除该选项？',
                    message: '删除后将被永久删除',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    iconClass: 'iconfont icon-yiwen',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    customClass: 'icon_title_message_box icon_title_message_box_danger',
                    confirmButtonClass: "el-button--danger",
                }).then(() => {
                    this.componentPropertyForm.extend.options.splice(index, 1)
                    this.$message.success('删除成功')
                    this.handleWorkorderTypeInputBlur()
                }).catch(() => {
                    return false
                })
            } else {
                if (this.componentPropertyForm.extend.options.length === 2) return this.$message.error('最少保留两个选项')
                this.componentPropertyForm.extend.options.splice(index, 1)
                this.$refs.componentPropertyForm.validateField('extend.options')
            }
        },

        //点击添加级联选项
        handleClickAddCascaderExtendOptions(options, has_child) {
            if (!options._child) {
                this.$set(options, '_child', [])
            }
            options._child.push({
                label: "",
                value: this.componentPropertyForm.extend.max_option_value,
            })
            this.componentPropertyForm.extend.max_option_value++
            this.$refs.componentPropertyForm.validateField('extend.cascader_options')
        },

        //点击删除级联选项
        handleClickDelCascaderExtendOptions(options, index, parent) {
            options.splice(index, 1)
            if (parent && parent._child && parent._child.length === 0) {
                delete parent._child
            }
            this.$refs.componentPropertyForm.validateField('extend.cascader_options')
        },

        //级联选项名称输入框失焦事件
        handleCascaderOptionsBlur() {
            this.$refs.componentPropertyForm.validateField('extend.cascader_options')
        },

        //选项设为默认
        handleClickDefaultOption(item) {
            this.componentPropertyForm.extend.options.forEach(option => {
                if (option.default) {
                    option.default = false
                }
                if (option.value === item.value) {
                    option.default = true
                }
            })
        },

        //选项输入框失焦事件
        handleOptionInputBlur() {
            this.$refs.componentPropertyForm.validateField('extend.options')
        },

        //地区组件地区精度选择事件
        handleAreaAccuracyChange(val) {
            let str = ''
            switch (val) {
                case '1':
                    str = '省-市-区/县'
                    break
                case '2':
                    str = '省-市'
                    break
                case '3':
                    str = '国家-地区'
                    break
            }
            this.componentPropertyForm.extend.area_accuracy_placeholder = '请选择' + str
        },

        //地区组件详细地址开关变化事件
        handleShowDetailAddressChange(val) {
            if (this.is_two_column) {
                if (val) {
                    this.$set(this.componentPropertyForm.extend, 'col_span', 24)
                } else {
                    this.$set(this.componentPropertyForm.extend, 'col_span', 12)
                }
            }
        },

        //日期区间类型切换
        handleDateRangeDateTypeChange(val) {
            if (val === 'timerange') {
                this.componentPropertyForm.extend.auto_computed = false
            }
        },

        //日期区间自动计算时长开关变化事件
        handleAutoComputedChange(val) {
            if (this.is_two_column) {
                if (val) {
                    this.$set(this.componentPropertyForm.extend, 'col_span', 24)
                } else {
                    this.$set(this.componentPropertyForm.extend, 'col_span', 12)
                }
            }
        },

        //获取审批类型列表
        getApprovalTypeList() {
            getApprovalType({
                approval_set_ids: []
            }).then(res => {
                if (res.code === 200) {
                    this.approvalTypeList = res.data
                }
            })
        },

        handleNotPromoterSelfChange(val) {
            this.componentPropertyForm.extend.self_in_approval_process_node = val
        },

        //点击添加发票比对信息设置
        handleClickAddSetting() {
            this.componentPropertyForm.extend.comparison_info_setting.push({
                purchaser_name: '', //名称
                purchaser_tax_number: '',//纳税人识别号
                purchaser_contact_info: '',//地址、电话
                purchaser_bank_account_info: '',//开户行及账号
            })
        },

        //点击删除发票比对信息设置
        handleClickDeleteSetting(index) {
            this.componentPropertyForm.extend.comparison_info_setting.splice(index, 1)
            if (this.componentPropertyForm.extend.comparison_info_setting.length === 0) {
                this.$refs.componentPropertyForm.validateField('extend.comparison_info_setting')
            }
        },

        //关联审批单配置可选范围切换事件
        handleOptionalRangeChange(val) {
            this.componentPropertyForm.extend.approve_form_scope = []
            if (this.approvalTypeList.length === 0) {
                this.getApprovalTypeList()
            }
        },

        //关联角色选择框聚焦事件
        handleRelateRolesSelectFocus() {
            if (this.relateRolesList.length === 0) {
                workOrderRoleList().then(res => {
                    if (res.code === 200) {
                        this.relateRolesList = res.data
                    } else {

                    }
                })
            }
        },

        //关联角色选择事件
        handleRelateRoleSelectChange(role) {
            this.componentPropertyForm.extend.relate_role_type = role.role_type
        },

        //点击前往
        handleClickGoToModify(type) {
            this.$router.replace({
                name: "AttendanceAdminManagement",
                params: {
                    tab: "holidayRule",
                },
            });
        },

        //点击上传示例文件
        handleUploadSampleFile() {
            const that = this
            const input = document.createElement('input')
            input.setAttribute('type', 'file')
            input.setAttribute('accept', '*')
            input.click()
            input.onchange = function () {
                const file = this.files[0];
                if (file.size > 10 * 1024 * 1024) return that.$message.error('图片大小不能超过10m')
                uploadImg(file).then(res => {
                    if (res.file_path) {
                        that.$set(that.componentPropertyForm.extend, 'sample_file', res)
                    }
                }).catch(() => {
                })
            }
        },

        //点击预览示例文件
        handleClickPreviewSampleFile() {
            const file = this.componentPropertyForm.extend.sample_file
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //点击删除示例文件
        handleClickDelSampleFile() {
            this.$set(this.componentPropertyForm.extend, 'sample_file', {})
        },

        //控件组字段设置
        handleCheckFieldShow(val, item) {
            item.extend.initial_display = !val
        },

        //允许添加多行程切换事件
        handleManyStrokeSubmitChange(val) {
            this.getChildField('travel_total_duration', this.componentPropertyForm).extend.initial_display = !val
        },

        //应付控件组付款类别开关切换事件
        handleCheckPaymentTypeShow(val) {
            this.getChildField('payable_op_payment_type', this.componentPropertyForm).extend.initial_display = !val
            this.getChildField('payable_op_payment_amount', this.componentPropertyForm).extend.initial_display = !val
        },

        //点击显隐设置
        handleBasicSettingGroupChange(val) {
            if (val === 'revealing' && Object.keys(this.conditionFieldList).length === 0) {
                this.getConditionFieldList()
            }
            if (val !== 'revealing' && this.basicSettingGroupFlag === 'revealing' && this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                this.basicSettingGroup = 'revealing'
                this.$nextTick(() => {
                    this.validateComponentPropertyFormRules().then(isValid => {
                        if (isValid) {
                            // 验证成功后的逻辑
                            this.basicSettingGroup = val
                            this.basicSettingGroupFlag = val
                        }
                    })
                })
            } else {
                this.basicSettingGroupFlag = val
            }
        },

        //校验当前表单中的显隐规则
        validateComponentPropertyFormRules() {
            const arrForm = []
            const formKey = this.componentPropertyForm.field_key
            const fieldType = this.componentPropertyForm.field_type
            this.componentPropertyForm.rules.forEach((group, index) => {
                if (Array.isArray(group) && group.length > 0) {
                    group.forEach((rule, child_index) => {
                        if (this.$refs.hasOwnProperty(`${formKey}_${fieldType}_condition_form_group${index}_${child_index}`)) {
                            arrForm.push(`${formKey}_${fieldType}_condition_form_group${index}_${child_index}`)
                        }
                    })
                }
            })
            return new Promise((resolve, reject) => {
                Promise.all(arrForm.map(item => this.deepFormValidate(item).catch(error => {
                    console.error(`Validation error for ${item}:`, error)
                    throw error
                }))).then(() => {
                    resolve(true)
                }).catch(() => {
                    this.$message.error('请将条件填写完整或者删除条件')
                    this.basicSettingGroup = 'revealing'
                    resolve(false)
                })
            })
        },

        //获取作为条件的字段列表
        getConditionFieldList() {
            this.conditionFieldList = {}
            if (this.is_form_module) {
                let list = []
                const parent_field = this.formInfoList.find(item => item.field_key === this.componentPropertyForm.p_field_key)
                if (parent_field && parent_field.field_type === 'form_module') {
                    list = this.formInfoList
                } else {
                    this.formInfoList.forEach(item => {
                        if (item._child && item._child.length) {
                            list = item._child.find(child.field_key === this.componentPropertyForm.p_field_key)
                        }
                    })
                }
                list.forEach(item => {
                    if (item._child && item._child.length) {
                        item._child.forEach(child => {
                            if (Number(child.sort) < Number(this.componentPropertyForm.sort)) {
                                if (child.field_type === 'number' || child.field_type === 'money') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                } else if (child.field_type === 'date_range') {
                                    if (child.extend.auto_compute) {
                                        this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                        this.conditionFieldList[child.field_key].condition_type = 'number'
                                        this.conditionFieldList[child.field_key].field_name = child.field_name + '-时长'
                                    } else {
                                        this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                        this.conditionFieldList[child.field_key].condition_type = 'date'
                                    }
                                } else if (child.field_type === 'compute_mode') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'number'
                                } else if (child.field_type === 'radio' || child.field_type === 'checkbox') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'options'
                                } else if (child.field_type === 'date') {
                                    if (!child.extend.default) {
                                        this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                        this.conditionFieldList[child.field_key].condition_type = 'date'
                                    }
                                } else if (child.field_type === 'department') {
                                    this.conditionFieldList[child.field_key] = JSON.parse(JSON.stringify(child))
                                    this.conditionFieldList[child.field_key].condition_type = 'department'
                                    if (this.depOptions.length === 0) {
                                        this.getDepartmentList()
                                    }
                                }
                                if (this.conditionFieldList[child.field_key]) {
                                    this.conditionFieldList[child.field_key].field_name = item.field_name + '.' + child.field_name
                                }
                            }
                        })
                    }
                })
            } else {
                if (this.componentPropertyForm.p_field_key) {
                    const parent_field = this.formInfoList.filter(item => item.field_key === this.componentPropertyForm.p_field_key)
                    if (parent_field._child && parent_field._child.length) {
                        parent_field._child.forEach(item => {
                            if (Number(item.sort) < Number(this.componentPropertyForm.sort)) {
                                if (item.field_type === 'number' || item.field_type === 'money') {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'number'
                                } else if (item.field_type === 'date_range') {
                                    if (item.extend.auto_compute) {
                                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                        this.conditionFieldList[item.field_key].condition_type = 'number'
                                        this.conditionFieldList[item.field_key].field_name = item.field_name + '-时长'
                                    } else {
                                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                        this.conditionFieldList[item.field_key].condition_type = 'date'
                                    }
                                } else if (item.field_type === 'compute_mode') {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'number'
                                } else if (item.field_type === 'radio' || item.field_type === 'checkbox') {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'options'
                                } else if (item.field_type === 'date') {
                                    if (!item.extend.default) {
                                        this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                        this.conditionFieldList[item.field_key].condition_type = 'date'
                                    }
                                } else if (item.field_type === 'department') {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'department'
                                    if (this.depOptions.length === 0) {
                                        this.getDepartmentList()
                                    }
                                }
                                if (this.conditionFieldList[child.field_key]) {
                                    this.conditionFieldList[child.field_key].field_name = parent_field.field_name + '.' + child.field_name
                                }
                            }
                        })
                    }
                } else {
                    this.formInfoList.forEach(item => {
                        if (Number(item.sort) < Number(this.componentPropertyForm.sort)) {
                            if (item.field_type === 'number' || item.field_type === 'money') {
                                this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                this.conditionFieldList[item.field_key].condition_type = 'number'
                            } else if (item.field_type === 'date_range') {
                                if (item.extend.auto_compute) {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'number'
                                    this.conditionFieldList[item.field_key].field_name = item.field_name + '-时长'
                                } else {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'date'
                                }
                            } else if (item.field_type === 'compute_mode') {
                                this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                this.conditionFieldList[item.field_key].condition_type = 'number'
                            } else if (item.field_type === 'radio' || item.field_type === 'checkbox') {
                                this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                this.conditionFieldList[item.field_key].condition_type = 'options'
                            } else if (item.field_type === 'date') {
                                if (!item.extend.default) {
                                    this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                    this.conditionFieldList[item.field_key].condition_type = 'date'
                                }
                            } else if (item.field_type === 'department') {
                                this.conditionFieldList[item.field_key] = JSON.parse(JSON.stringify(item))
                                this.conditionFieldList[item.field_key].condition_type = 'department'
                                if (this.depOptions.length === 0) {
                                    this.getDepartmentList()
                                }
                            } else if (item.field_type === 'control') {

                            }
                        }
                    })
                }
            }
        },

        //获取部门列表
        getDepartmentList() {
            GetDepartmentList().then(res => {
                if (res.code === 200) {
                    this.depOptions = res.data || []
                } else {

                }
            })
        },

        //选择条件中的部门事件
        handleDepartmentCheckChange(data, checked, indeterminate, child) {
            if (checked) {
                child.field_value.titles.push(data.relate_name)
                child.field_value.dids.push(data.relate_id)
            } else {
                child.field_value.titles.splice(child.field_value.titles.indexOf(data.relate_name), 1)
                child.field_value.dids.splice(child.field_value.dids.indexOf(data.relate_id), 1)
            }
        },

        handleDepartmentFocus(child, ref_def) {
            let ref = 'department' + ref_def
            const keys = child.field_value.dids.map(item => item)
            child.field_value.dids = []
            child.field_value.titles = []
            this.$refs[ref][0].setCheckedKeys([])
            this.$nextTick(() => {
                this.$refs[ref][0].setCheckedKeys(keys)
            })
        },

        // 点击删除
        handleClickRemoveDepartment(tag, child, ref_def) {
            child.field_value.dids.splice(0, 1)
            const keys = child.field_value.dids.map(item => item)
            child.field_value.dids = []
            child.field_value.titles = []
            this.$refs['department' + ref_def][0].setCheckedKeys([])
            this.$nextTick(() => {
                this.$refs['department' + ref_def][0].setCheckedKeys(keys)
            })
        },

        handleClickClearDepartment(child, ref_def) {
            child.field_value.dids = []
            const keys = child.field_value.dids.map(item => item)
            child.field_value.dids = []
            child.field_value.titles = []
            this.$refs['department' + ref_def][0].setCheckedKeys([])
            this.$nextTick(() => {
                this.$refs['department' + ref_def][0].setCheckedKeys(keys)
            })
        },

        //点击添加条件组
        handleClickAddConditionGroup() {
            this.componentPropertyForm.rules.push([
                {
                    type: 'field',
                    field_key: '',
                    operator: '',
                    field_value: '',
                }
            ])
            this.getConditionFieldList()
            if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                this.componentPropertyForm.extend.initial_display = true
            }
        },

        //点击删除条件组
        handleClickDelConditionGroup(index) {
            this.componentPropertyForm.rules.splice(index, 1)
            if (this.componentPropertyForm.rules.length === 0) {
                this.componentPropertyForm.extend.initial_display = false
            }
        },

        //点击添加条件
        handleClickAddCondition(item) {
            item.push({
                type: 'field',
                field_key: '',
                p_field_key: '',
                operator: '',
                field_value: '',
            })
            this.getConditionFieldList()
        },

        //点击删除条件
        handleClickDelCondition(child_index, item, index) {
            item.splice(child_index, 1)
            if (item.length === 0) {
                this.componentPropertyForm.rules.splice(index, 1)
            }
            if (this.componentPropertyForm.rules.length === 0) {
                this.componentPropertyForm.extend.initial_display = false
            }
        },

        //选择条件字段变化事件
        handleSelectConditionFieldChange(val, child, item) {
            child.operator = ''
            child.field_value = ''
            const field = this.conditionFieldList[child.field_key]
            if (field.condition_type === 'date') {
                child.field_value = {
                    value: '',
                    date: '',
                }
            } else if (field.condition_type === 'department') {
                if (item.filter(children => children.field_key === field.field_key).length > 1) {
                    child.field_key = ''
                    return this.$message.error('当前控件已作为其他条件，不允许再次选择')
                }
                child.field_value = {
                    titles: [],
                    dids: []
                }
            } else if (field.condition_type === 'number') {
                if (item.filter(children => children.field_key === field.field_key).length > 2) {
                    child.field_key = ''
                    return this.$message.error('当前控件已作为其他条件，不允许再次选择')
                }
                child.field_value = undefined
            } else if (field.condition_type === 'options') {
                if (item.filter(children => children.field_key === field.field_key).length > 1) {
                    child.field_key = ''
                    return this.$message.error('当前控件已作为其他条件，不允许再次选择')
                }
                if (field.field_type === 'checkbox') {
                    child.field_value = []
                } else {
                    child.field_value = ''
                }
            }
            child.p_field_key = field.p_field_key
        },

        //条件选择框聚焦事件，获取控件对应的条件
        getOperatorSelectList(child) {
            let arr = []
            if (child.field_key) {
                const field = this.conditionFieldList[child.field_key]
                if (field) {
                    if (field.field_type === 'radio') {
                        arr = [
                            {label: '选中', value: 'in'},
                            {label: '未选中', value: 'not_in'}
                        ]
                    } else if (field.field_type === 'checkbox') {
                        arr = [
                            {label: '完全匹配', value: 'eq'},
                            {label: '属于以下任意', value: 'between'},
                            {label: '不属于', value: 'not_between'},
                        ]
                    } else if (field.field_type === 'number' ||
                            field.field_type === 'money' ||
                            field.field_type === 'compute_mode' ||
                            field.field_type === 'computed_money') {
                        arr = [
                            {label: '大于', value: 'gt'},
                            {label: '大于等于', value: 'egt'},
                            {label: '等于', value: 'eq'},
                            {label: '小于等于', value: 'elt'},
                            {label: '小于', value: 'lt'},
                        ]
                    } else if (field.field_type === 'date') {
                        arr = [
                            {label: '早于', value: 'lt'},
                            {label: '等于', value: 'eq'},
                            {label: '晚于', value: 'gt'},
                        ]
                    } else if (field.field_type === 'date_range') {
                        if (field.auto_computed) {
                            arr = [
                                {label: '大于', value: 'gt'},
                                {label: '大于等于', value: 'egt'},
                                {label: '等于', value: 'eq'},
                                {label: '小于等于', value: 'elt'},
                                {label: '小于', value: 'lt'},
                            ]
                        } else {
                            arr = [
                                {label: '早于', value: 'lt'},
                                {label: '等于', value: 'eq'},
                                {label: '晚于', value: 'gt'},
                            ]
                        }
                    } else if (field.field_type === 'department') {
                        if (field.select_range === '1') {
                            arr = [
                                {label: '属于以下任意', value: 'between'},
                                {label: '不属于', value: 'not_between'},
                            ]
                        } else {
                            arr = [
                                {label: '完全匹配', value: 'eq'},
                                {label: '属于以下任意', value: 'between'},
                                {label: '不属于', value: 'not_between'},
                            ]
                        }
                    }
                }
            }
            return arr
        },

        //点击预览
        handleClickReview() {
            this.reviewFormDialog = true
            this.reviewFormType = this.review_form_type_list[0].value
            this.reviewFormTitle = this.review_form_type_list[0].form_title
        },

        // 切换extend 中 show_field 是否选中
        handleChangeToggleField(field) {
            const index = this.componentPropertyForm.extend.show_field.indexOf(field);
            if (index > -1) {
                this.componentPropertyForm.extend.show_field.splice(index, 1);
            } else {
                this.componentPropertyForm.extend.show_field.push(field);
            }
        },

        //点击发布
        handleClickPublish() {
            if (this.$refs.componentPropertyForm) {
                this.$refs.componentPropertyForm.validate((valid, errors) => {
                    if (valid) {
                        if (this.componentPropertyForm.rules && this.componentPropertyForm.rules.length > 0) {
                            this.validateComponentPropertyFormRules().then(isValid => {
                                if (isValid) {
                                    this.publishFunction()
                                }
                            })
                        } else {
                            this.publishFunction()
                        }
                    } else {
                        const firstErrorField = Object.keys(errors)[0]; // 获取第一个校验失败的字段
                        this.$message.error(errors[firstErrorField][0].message)
                    }
                })
            } else {
                this.publishFunction()
            }
        },

        //表单发布事件
        publishFunction() {
            const data = {
                field_form: this.field_form,
                field_list: this.formInfoList,
                quote_form: this.quote_form,
            }
            if (this.publish_btn_show) {
                this.btnDisabled = true
                //如果有发布按钮，调用发布接口
                saveFormFields(data).then(res => {
                    if (res.code === 200) {
                        this.$message.success('设置成功')
                        this.btnDisabled = false
                    } else {

                    }
                })
            } else {
                //没有则直接将数据返回
                this.$emit('submit-fields', data)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.custom_form_site_wrap {
    width: 100%;
    height: 100%;

    .custom_form_site_outer_wrap {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .left_components_wrap {
            width: 340px;
            height: 100%;
            border-radius: 0 0 0 8px;
            box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
            padding: 16px 4px 16px 16px;

            .components_options_tabs {
                height: 40px;
                margin-bottom: 24px;
                border-radius: 100px;
                background: #F7F7F7;
                box-shadow: inset 1px 0px 3px rgba(0, 0, 0, 0.1), inset 0px 2px 4px rgba(0, 0, 0, 0.15);
                display: flex;
                align-items: center;
                padding: 1px;

                .components_options_tab {
                    flex: 1;
                    text-align: center;
                    color: #333333;
                    height: 100%;
                    line-height: 38px;
                    cursor: pointer;

                    &.active {
                        border-radius: 100px;
                        background: rgba(255, 255, 255, 1);
                        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
                        color: #2990FF;
                        font-weight: bold;
                    }
                }
            }

            .controls_outer_wrap {
                width: 100%;
            }

            .control_group_outer_wrap {
                width: 100%;
                height: calc(100% - 65px);
            }

            .components_options_list {
                margin-top: 16px;
                width: 100%;
                height: calc(100% - 60px);
                overflow-y: auto;
                padding-right: 8px;

                &::-webkit-scrollbar {
                    width: 0 !important;
                }

                .components_options_item {
                    margin-bottom: 16px;

                    .popular_control_icon {
                        width: 16px;
                        height: 16px;
                    }

                    h3 {
                        font-size: 14px;
                        font-weight: 700;
                        line-height: 22px;
                        color: #333333;
                    }

                    .control_types_list {
                        width: 100%;

                        .control_draggable {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px;

                            .chosen {
                                border-color: #2990ff !important;
                            }

                            .control_types_item {
                                width: calc(50% - 6px);
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                cursor: pointer;
                                padding: 5px 12px;
                                border-radius: 4px;
                                border: 1px solid #D9D9D9;
                                line-height: 22px;

                                .control_types_name {
                                    color: #666666;
                                }

                                .control_types_icon {
                                    color: #666666;
                                }

                                &.is_disabled {
                                    cursor: not-allowed;
                                    background-color: rgba(247, 247, 247, 1);
                                }
                            }
                        }
                    }
                }
            }

            .components_options_list::-webkit-scrollbar-thumb {
                background-color: #888; /* 设置滚动条颜色 */
            }
        }

        .center_form_wrap {
            flex: 1;
            height: 100%;
            padding: 16px 24px;
            min-width: 620px;
            overflow: hidden;

            .center_title_wrap {
                display: flex;
                justify-content: space-between;
                padding-bottom: 24px;
            }

            .center_form_review_wrap {
                width: calc(100% + 8px);
                height: calc(100% - 70px);
                overflow-y: auto;
                padding: 0 8px 8px 0;

                .form_module_wrap {
                    border-radius: 8px;
                    border: 1px solid #E8E8E8;
                    cursor: pointer;
                    margin-bottom: 16px;
                    padding: 8px;

                    &.active {
                        box-shadow: 0 3px 6px 2px rgba(0, 0, 0, 0.08);
                        border: 1px solid #2990ff;
                    }

                    .form_module_title_wrap {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        position: relative;
                        padding: 8px;

                        &::before {
                            content: '';
                            width: 4px;
                            height: 22px;
                            border-radius: 20px;
                            background: #2990FF;
                            display: block;
                            position: absolute;
                            left: 4px;
                        }

                        .field_name_input {
                            width: 244px;
                            margin-left: 8px;

                            ::v-deep .el-input__inner {
                                line-height: 30px;
                                height: 30px;
                                border: none;
                                background: rgba(0, 0, 0, 0.04);
                                border-radius: 4px;
                                padding: 0 8px;
                                color: #333333;
                            }
                        }

                        .field_name_wrap {
                            height: 30px;
                            line-height: 22px;
                            padding: 4px 8px;
                            border-radius: 4px;
                            height: 30px;

                            &.can_edit:hover {
                                background: rgba(0, 0, 0, 0.04);
                                margin-left: 8px;

                                .edit_icon_wrap {
                                    display: inline-block;
                                }
                            }

                            .field_name {
                                font-size: 14px;
                                font-weight: 700;
                                color: #333333;
                                margin-right: 4px;
                                display: inline-block;
                                line-height: 22px;
                                vertical-align: top;
                            }

                            .edit_icon_wrap {
                                display: none;
                            }
                        }

                        .handle_icon_wrap {
                            margin-left: 16px;
                        }
                    }

                    .amount_information_hint {
                        text-align: center;
                        color: #999999;
                        padding: 80px 0 58px;
                    }
                }

                .form_module_content_wrap {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;

                    .field_outer_wrap {
                        padding: 8px;

                        &:hover {
                            border-radius: 6px;
                            background: rgba(0, 0, 0, 0.04);
                        }

                        &.active {
                            border-radius: 6px;
                            background: rgba(41, 144, 255, 0.08);
                        }

                        .el-form-item {
                            margin-bottom: 0 !important;
                        }

                        .center_field_label {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            line-height: 22px;
                            margin-bottom: 4px;

                            .el-icon-remove {
                                color: #BFBFBF;
                                font-size: 16px;
                                cursor: pointer;

                                &.is_disabled {
                                    color: #D9D9D9;
                                }
                            }

                            .field_name_input {
                                width: 244px;

                                ::v-deep .el-input__inner {
                                    line-height: 30px;
                                    height: 30px;
                                    border: none;
                                    background: rgba(0, 0, 0, 0.04);
                                    border-radius: 4px;
                                    padding: 0 8px;
                                    color: #333333;
                                }
                            }

                            .field_name_wrap {
                                line-height: 22px;
                                padding: 4px 8px;
                                border-radius: 4px;
                                height: 30px;

                                &.is_required::before {
                                    content: '*';
                                    position: absolute;
                                    left: 0;
                                    color: #E44144;
                                }

                                &.can_edit:hover {
                                    background: rgba(0, 0, 0, 0.04);
                                    margin-left: 8px;

                                    .edit_icon_wrap {
                                        display: inline-block;
                                    }
                                }

                                .field_name {
                                    font-size: 14px;
                                    font-weight: 700;
                                    color: #333333;
                                    margin-right: 4px;
                                    display: inline-block;
                                    line-height: 22px;
                                    vertical-align: top;
                                }

                                .edit_icon_wrap {
                                    display: none;
                                }
                            }

                            ::v-deep .el-checkbox {
                                margin-right: 16px;
                            }

                            .page_little_title {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .form_module_empty_wrap {
                    width: 100%;
                    height: 126px;
                    background-color: rgba(0, 0, 0, 0.04);
                    border-radius: 6px;
                    text-align: center;
                    line-height: 126px;
                    color: #999999;
                    margin-top: 16px;
                    margin-bottom: 8px;
                }
            }

            .center_add_form_module_btn {
                width: 100%;
                text-align: center;
                padding: 5px 0;
                border: 1px dashed #2990ff;
                cursor: pointer;
                color: #2990ff;
                border-radius: 8px;
            }

            ::v-deep .el-checkbox__label {
                padding-left: 8px;
            }
        }

        .right_components_site_wrap {
            width: 342px;
            height: 100%;
            border-radius: 0 0 8px 0;
            box-shadow: -2px 0 4px rgba(0, 0, 0, 0.08);

            .right_components_inner_wrap {
                width: 100%;
                height: 100%;

                h2 {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                    padding: 16px;
                    margin-bottom: 0;
                    border-bottom: 1px solid #E8E8E8;
                }

                .right_components_form_wrap {
                    width: 100%;
                    height: calc(100% - 57px);
                    padding: 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 24px;

                    .title_radio_group {
                        width: 100%;
                        display: flex;

                        .el-radio-button {
                            flex: 1;

                            ::v-deep .el-radio-button__inner {
                                width: 100%;
                            }
                        }
                    }

                    ::v-deep .el-form {
                        flex: 1;
                        overflow-y: auto;
                        overflow-x: hidden;
                    }

                    .system_field_can_not_edit {
                        border-radius: 4px;
                        background: #EDF0F4;
                        line-height: 22px;
                        padding: 4px 8px;
                        color: #666666;
                        font-size: 14px;
                        margin-bottom: 12px;
                    }

                    .amount_information_list {
                        .amount_information_item {
                            border-radius: 6px;
                            border: 1px solid #E8E8E8;
                            padding: 10px 12px 12px;
                            margin-bottom: 12px;

                            .field_name_h3 {
                                font-size: 14px;
                                line-height: 22px;
                            }

                            .applicable_products {
                                font-size: 12px;
                                line-height: 18px;
                                color: #999999;
                            }

                            .formula_text {
                                color: #666666;
                                margin-top: 4px;
                            }
                        }
                    }

                    .add_amount_information_btn {
                        width: 100%;
                        text-align: center;
                        padding: 5px 0;
                        border: 1px dashed #2990ff;
                        cursor: pointer;
                        color: #2990ff;
                        border-radius: 4px;
                    }

                    .property_radio_group {
                        .el-radio {
                            display: block;
                            margin-right: 0;
                            line-height: 22px;
                            margin-bottom: 12px;
                            color: #666666;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .property_checkbox_group {
                        .el-checkbox {
                            display: block;
                            margin-right: 0;
                            line-height: 22px;
                            margin-bottom: 12px;
                            color: #666666;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }

                    .hint {
                        font-size: 12px;
                        line-height: 18px;
                        color: #999999;
                        margin-top: 2px;
                    }

                    .is_form_show_wrap {
                        border-top: 1px solid #E8E8E8;
                        padding-top: 12px;
                    }

                    ::v-deep .el-form-item__label {
                        font-weight: bold;
                        width: 100%;
                        display: inline-flex;

                        .label_btn_wrap {
                            display: inline-flex;
                            width: 100%;
                            align-items: center;
                            justify-content: space-between;
                        }
                    }

                    ::v-deep .el-form-item__content {
                        line-height: 22px;
                    }

                    ::v-deep .error_msg_display_none {
                        display: none;
                    }

                    .count_scope_wrap {
                        display: flex;
                        gap: 16px;

                        .el-input-number {
                            flex: 1;
                        }
                    }

                    .el-select {
                        width: 100%;
                    }

                    .extend_options_list {
                        .extend_options_item {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            line-height: 32px;
                            margin-bottom: 12px;

                            &:last-child {
                                margin-bottom: 0;
                            }

                            .icon-a-move {
                                cursor: move;
                                color: rgba(0, 0, 0, 0.16);
                                vertical-align: middle;
                                font-size: 16px;
                            }

                            .input_radio_wrap {
                                display: flex;
                                align-items: center;
                                gap: 12px;
                                line-height: 22px;
                                padding: 4px 12px;
                                border-radius: 4px;
                                border: 1px solid #D9D9D9;
                                box-sizing: border-box;
                                flex: 1;

                                ::v-deep .el-input--mini {
                                    height: 22px;
                                    flex: 1;
                                }

                                ::v-deep .el-input--mini .el-input__inner {
                                    border: none;
                                    height: 22px;
                                    line-height: 22px;
                                    padding: 0;
                                }

                                .is_defaut_wrap {
                                    line-height: 22px;
                                    cursor: pointer;
                                    width: 80px;

                                    &.is_active {
                                        .radio_span {
                                            border: 1px solid #2990FF;

                                            &::before {
                                                background: #2990FF;
                                            }
                                        }

                                        .radio_text {
                                            color: #2990FF;
                                        }
                                    }

                                    .radio_span {
                                        display: inline-block;
                                        margin-right: 8px;
                                        width: 16px;
                                        height: 16px;
                                        border: 1px solid #D9D9D9;
                                        border-radius: 50%;
                                        vertical-align: middle;
                                        position: relative;

                                        &::before {
                                            content: '';
                                            width: 8px;
                                            height: 8px;
                                            border-radius: 50%;
                                            display: inline-block;
                                            position: absolute;
                                            top: 50%;
                                            left: 50%;
                                            transform: translate(-50%, -50%);
                                        }
                                    }

                                    .radio_text {
                                        display: inline-block;
                                        vertical-align: middle;
                                        line-height: 22px;
                                        color: #666666;
                                    }
                                }
                            }

                            .handle_icon_wrap:hover {
                                .icon-fenlei_jilian {
                                    color: #2990FF;
                                }
                            }

                            .icon-fenlei_jilian {
                                cursor: pointer;
                                color: #333333;
                                vertical-align: middle;
                                font-size: 16px;

                                &.is_disabled {
                                    color: #BFBFBF;
                                    cursor: not-allowed;
                                }
                            }

                            .icon-guanbi_dise {
                                cursor: pointer;
                                color: #BFBFBF;
                                vertical-align: middle;
                                font-size: 16px;
                            }
                        }
                    }

                    .add_extend_options_btn {
                        text-align: center;
                        width: 100%;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 18px;
                        text-align: center;
                        color: #2990FF;
                        cursor: pointer;
                        padding: 3px 0;
                        border: 1px dashed #2990FF;
                        margin-top: 12px;
                        border-radius: 4px;
                    }

                    .tag_interaction_wrap {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        line-height: 22px;
                    }

                    .upload_sample_file_btn {
                        border-radius: 4px;
                        border: 1px solid #D9D9D9;
                        line-height: 32px;
                        padding: 0 16px;
                        cursor: pointer;
                        margin-top: 16px;
                        width: fit-content;
                        font-size: 14px;
                        height: 32px;

                        .icon-upload {
                            vertical-align: middle;
                            margin-right: 4px;
                            font-size: 14px;
                        }
                    }

                    .sample_file_wrap {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        justify-content: space-between;
                        background-color: #EDF0F4;
                        border-radius: 4px;
                        padding: 4px;
                        margin-top: 16px;

                        .file_name {
                            flex: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    .field_site_wrap {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 4px 8px;
                        border-radius: 4px;
                        background: #EDF0F4;
                        color: #333333;
                        margin-bottom: 8px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            vertical-align: middle;
                        }
                    }

                    .comparison_info_item {
                        border-radius: 4px;
                        background: #F7F8FA;
                        padding: 12px 12px 1px;
                        margin-top: 12px;
                        position: relative;

                        ::v-deep .el-form.el-form--label-top .el-form-item__label {
                            font-weight: normal;
                        }

                        .el-icon-remove {
                            position: absolute;
                            right: 0;
                            top: -8px;
                            cursor: pointer;
                            color: #BFBFBF;
                            font-size: 16px;
                        }
                    }

                    .rules_set_form {
                        .icon-shuoming {
                            font-weight: normal;
                            margin-left: 8px;
                        }
                    }

                    .condition_group_list {
                        margin-top: 12px;

                        .condition_group_item {
                            border-radius: 4px;
                            border: 1px solid #E8E8E8;
                            margin-bottom: 24px;
                            position: relative;

                            .condition_group_title_wrap {
                                padding: 8px 12px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                background-color: #EDF0F4;
                                border-radius: 4px;

                                .condition_group_title {
                                    line-height: 22px;
                                    color: #333333;
                                    font-weight: 700;
                                }
                            }

                            .condition_list {
                                padding: 12px;

                                .condition_item {
                                    .condition_item_title_wrap {
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                        line-height: 22px;
                                        margin-bottom: 4px;
                                    }

                                    ::v-deep .el-form-item {
                                        margin-bottom: 12px !important;

                                        .el-input-number--small {
                                            width: 100% !important;
                                            text-align: left;
                                        }

                                        .el-input-number .el-input__inner {
                                            text-align: left;
                                            padding-left: 15px;
                                        }

                                        .el-date-editor.el-input {
                                            width: 100% !important;
                                        }
                                    }
                                }
                            }

                            .either {
                                position: absolute;
                                left: 10px;
                                bottom: -24px;
                            }
                        }
                    }

                    .explain_box {
                        padding: 8px 12px;
                        color: #666666;
                        border-radius: 4px;
                        background: #EDF0F4;
                        margin-top: 12px;
                        line-height: 22px;
                    }

                    ::v-deep .el-slider {
                        display: flex;
                        justify-content: center;

                        .el-slider__runway {
                            width: 94%;
                        }
                    }

                    .E8E8E8_line {
                        width: 100%;
                        height: 1px;
                        background: #E8E8E8;
                        margin-bottom: 12px;
                    }
                }
            }
        }

        h2 {
            font-weight: 700;
            line-height: 24px;
            margin-bottom: 4px;
            font-size: 16px;
        }

        .title_desc {
            font-size: 12px;
            line-height: 18px;
            color: #666666;
        }
    }

    .quick_add_option_hint {
        line-height: 22px;
        color: #333333;
        margin-bottom: 4px;
    }
}
</style>
<style lang="scss">
.little_hint {
    font-size: 12px;
    line-height: 18px;
    color: #999999;
}

.department_user_select {
    width: 100%;
}

.textarea_outer_wrap {
    position: relative;
    height: 180px;
    border: 1px solid #D9D9D9;
    border-radius: 2px;

    .textarea_wrap {
        padding: 12px 0 0 12px;
        height: 150px;
        color: #666666;
        overflow-y: auto;
        text-indent: 5em;
        line-height: 22px;

        span {
            text-indent: 0;
        }

        &:hover {
            border-color: #C0C4CC;
        }

        &:focus {
            outline: 0;
            border-color: #1990ff;
        }
    }

    .placeholder {
        position: absolute;
        top: 12px;
        left: 12px;
        line-height: 22px;
    }

    .delete_btn {
        position: absolute;
        bottom: 10px;
        right: 50px;
        cursor: pointer;
        line-height: 22px;
    }

    .clear_btn {
        color: #FF4D4F;
        position: absolute;
        bottom: 8px;
        right: 12px;
        cursor: pointer;
        line-height: 22px;
    }
}

.components_list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .components_item {
        line-height: 22px;
        padding: 0 8px;
        background: #EDF0F4;
        cursor: pointer;
        border-radius: 2px;
        text-indent: 0;
        color: #333333;
    }
}

.formula_item {
    line-height: 22px;
    padding: 0 6px;
    background: #EDF0F4;
    margin: 0 2px 10px;
    cursor: pointer;
    border-radius: 2px;
    display: inline-block;
}

.department_user_wrap {
    width: 100%;
    height: 410px;
    display: flex;
    gap: 16px;
    width: 100%;

    .left_selectable_wrap {
        flex: 1;
        height: 100%;
        border-radius: 6px;
        border: 1px solid #F3F3F3;

        .title_wrap {
            display: inline-flex;
            align-items: center;
            justify-content: start;
            border-bottom: 1px solid #f3f3f3;
            box-sizing: border-box;
            width: 100%;
            height: 46px;

            .type_title {
                padding: 12px 16px;
                color: #333333;
                font-size: 16px;
                line-height: 18px;
                cursor: pointer;

                &.active {
                    color: #1990ff;
                    font-weight: 700;
                    border-bottom: 2px solid #1990ff;
                }
            }
        }

        .selectable_wrap {
            width: 100%;
            height: calc(100% - 46px);
            overflow-y: auto;
            padding: 16px;

            .select_type_1_wrap .el-checkbox {
                display: block;
                margin-right: 0;
                margin-bottom: 12px;
            }

            .el-input__suffix {
                line-height: 32px;
            }

            .scroll_wrap {
                margin-top: 10px;
                width: 100%;
                height: calc(100% - 42px);
                overflow-y: auto;
            }
        }
    }

    .right_selected_wrap {
        flex: 1;
        height: 100%;
        border-radius: 6px;
        border: 1px solid #F3F3F3;

        .title_wrap {
            .selected_count {
                .text {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 18px;
                }

                .count {
                    color: #666666;
                    font-size: 12px;
                    line-height: 18px;
                }
            }

            .clear_btn {
                color: #E44144;
                cursor: pointer;
                line-height: 22px;
            }
        }

        .selected_list {
            height: calc(100% - 46px);
            overflow-y: auto;
            padding: 4px;

            .selected_item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 4px 12px;
                border-radius: 4px;
                color: #666666;
                line-height: 22px;

                &:hover {
                    background-color: rgba(0, 0, 0, 0.04);
                    color: #333333;

                    .el-icon-error {
                        display: block;
                    }
                }

                .el-icon-error {
                    font-size: 16px;
                    color: #BFBFBF;
                    cursor: pointer;
                    display: none;
                }
            }
        }
    }

    .title_wrap {
        height: 46px;
        color: #333333;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f3f3f3;
        box-sizing: border-box;
    }
}

.value_config_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #EDF0F4;
    border-radius: 4px;
    margin-bottom: 8px;
    line-height: 22px;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }

    .el-input {
        width: 150px;

        .el-input__inner {
            height: 22px;
            line-height: 22px;
        }
    }

    .value_config_name {
        color: #333333;
        height: 22px;
        line-height: 22px;

        .config_name {
            font-size: 14px;
        }

        &:hover {
            .handle_icon_wrap {
                display: inline-block;
            }
        }

        .handle_icon_wrap {
            display: none;
        }
    }
}

.purchase_details_list {
    width: 100%;
    border-top: 1px solid rgba(232, 232, 232, 1);
    padding-top: 2px;

    .purchase_details_item {
        margin-top: 12px;
    }
}

.formula_edit_dialog {
    .el-dialog {
        min-height: 50vh;
        max-height: 85vh;
        display: flex;
        flex-direction: column;
    }

    .el-dialog__body {
        flex: 1;
        overflow-y: auto !important;
        overflow-x: hidden;
    }
}
</style>